var Rt = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
};
var Se = (e, t, n) => (Rt(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Vt = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, Ft = (e, t, n, r) => (Rt(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import { createAxios as Mn } from "@dustess/iquery";
import { cloneDeep as xt } from "lodash-es";
const Ut = [
  "updateAppMessageShareData",
  "updateTimelineShareData",
  "onMenuShareTimeline",
  "onMenuShareAppMessage",
  "onMenuShareQQ",
  "onMenuShareWeibo",
  "onMenuShareQZone",
  "startRecord",
  "stopRecord",
  "onVoiceRecordEnd",
  "playVoice",
  "pauseVoice",
  "stopVoice",
  "onVoicePlayEnd",
  "uploadVoice",
  "downloadVoice",
  "chooseImage",
  "previewImage",
  "uploadImage",
  "downloadImage",
  "translateVoice",
  "getNetworkType",
  "openLocation",
  "getLocation",
  "hideOptionMenu",
  "showOptionMenu",
  "hideMenuItems",
  "showMenuItems",
  "hideAllNonBaseMenuItem",
  "showAllNonBaseMenuItem",
  "closeWindow",
  "scanQRCode",
  "openProductSpecificView",
  "addCard",
  "chooseCard",
  "openCard",
  // 历史jsapi
  "previewFile",
  "checkJsApi",
  "openEnterpriseChat",
  "getCurExternalChat",
  "onHistoryBack",
  "agentConfig",
  "openDefaultBrowser",
  "setClipboardData",
  "openAddress",
  "launchMiniprogram",
  "navigateToAddCustomer",
  "shareToExternalContact",
  "openExistedChatWithMsg",
  "shareToExternalMoments",
  "selectExternalContact",
  "sendChatMessage",
  "getCurExternalContact",
  "onMenuShareWechat"
], kt = [
  "menuItem:exposeArticle",
  "menuItem:setFont",
  "menuItem:dayMode",
  "menuItem:nightMode",
  "menuItem:refresh",
  "menuItem:profile",
  "menuItem:addContact",
  "menuItem:share:appMessage",
  "menuItem:share:timeline",
  "menuItem:share:qq",
  "menuItem:share:weiboApp",
  "menuItem:favorite",
  "menuItem:share:facebook",
  "menuItem:share:QZone",
  "menuItem:editTag",
  "menuItem:delete",
  "menuItem:copyUrl",
  "menuItem:originPage",
  "menuItem:readMode",
  "menuItem:openWithQQBrowser",
  "menuItem:openWithSafari",
  "menuItem:share:email",
  "menuItem:share:brand"
], wn = [
  "checkJsApi"
], yn = [
  "checkJsApi"
], Gn = [
  "menuItem:share:appMessage"
], In = [
  "menuItem:share:appMessage"
], Wt = () => new Promise((e, t) => {
  const { wx: n } = window;
  (!n || !n.ready) && t(!1), n.ready(() => {
    console.log("wx.ready:", window), e(!0);
  }), n.error((r) => {
    console.log("wx.error:", window), console.error(`${r.errMsg}:=:微信SDK注册失败`), window.location.href.startsWith("http:") ? (console.error(`${r.errMsg}:=:微信SDK注册失败(location)`), e(!0)) : t(!1);
  });
}), En = (e) => new Promise(async (t, n) => {
  const r = await Cn(e);
  if (console.log("jwconfig:", r), r) {
    let u = [];
    const { wx: s } = window;
    if (r.ticketType) {
      Xt(r.corp, r.corpApis);
      const l = await Wt();
      console.log("isready1:", window), l || (console.error("isready1!", window.wx), n(!1)), s != null && s.agentConfig ? s.agentConfig({
        ...r.agent,
        jsApiList: r.agentApis,
        success: function(T) {
          console.log("wx.agentConfig:jsApiList ", r.agentApis), console.log("wx.agentConfig:success ", T), t(!0);
        },
        fail: (T) => {
          console.error("wx.agentConfig:fail ", T), T.errMsg.indexOf("function not exist") > -1 && console.info("agentConfig 版本过低请升级"), n(!1);
        }
      }) : t(!0), u = [...r.corpApis, ...r.agentApis];
    } else {
      Xt(r.corp, r.corpApis);
      const l = await Wt();
      console.log("isready2:", window), l ? t(!0) : (console.error("isready2!", window.wx), n(!1)), u = r.corpApis;
    }
    s.checkJsApi({
      jsApiList: u,
      success: (l) => {
        console.log("wx.checkJsApi:success ", l);
      }
    });
  } else
    console.error("set util config!"), n(!1);
}), Cn = (e) => new Promise((t, n) => {
  var r, u, s, l, T, p, v, g;
  if (e) {
    let i = [];
    e.filterList.length && (i = e.filterList || []);
    let h = [];
    e.platformType === "wx-platform" && (h = i.filter((Y) => Y.ticketType === "official")), e.platformType === "qw-platform" && (h = i.filter((Y) => Y.ticketType === "corp"));
    const m = i.filter((Y) => Y.ticketType === "agent"), G = {
      beta: !0,
      debug: e.query.debug
    }, D = {
      ...G,
      timestamp: h[0].timestamp,
      nonceStr: h[0].nonce,
      signature: h[0].signature,
      appId: h[0].appId || e.query.corpId,
      openTagList: e.openTagList
    }, O = {
      ...G,
      timestamp: (r = m == null ? void 0 : m[0]) == null ? void 0 : r.timestamp,
      nonceStr: (u = m == null ? void 0 : m[0]) == null ? void 0 : u.nonce,
      signature: (s = m == null ? void 0 : m[0]) == null ? void 0 : s.signature,
      corpid: e.query.corpId,
      agentid: (l = e.query) == null ? void 0 : l.agentId
    }, U = [...yn, ...In, ...((T = e.jsApis) == null ? void 0 : T[0]) || [], ...((p = e.jsMenus) == null ? void 0 : p[0]) || []], N = [...wn, ...Gn, ...((v = e.jsApis) == null ? void 0 : v[1]) || [], ...((g = e.jsMenus) == null ? void 0 : g[1]) || []], Z = {
      agent: { ...O },
      corp: { ...D },
      corpApis: e.isEach ? U : [...Ut, ...kt, ...e.jsApiList],
      agentApis: e.isEach ? N : [...Ut, ...kt, ...e.jsApiList],
      ticketType: !!m.length
    };
    console.log("utilConfig:", Z), t({
      ...Z
    });
  } else
    n(!1);
}), Xt = (e, t) => {
  const { wx: n } = window;
  n.config({
    ...e,
    jsApiList: t
  });
}, { webGateway: ke } = Mn({
  baseURL: "",
  withCredentials: !0
});
var Kt;
((e) => {
  ((t) => {
    t[t.bizMin = 0] = "bizMin", t[t.bizWxCardMini = 1] = "bizWxCardMini", t[t.bizWxOfficial = 2] = "bizWxOfficial", t[t.bizTikTokMini = 3] = "bizTikTokMini", t[t.bizWxMallMini = 4] = "bizWxMallMini", t[t.bizWxActivityMini = 5] = "bizWxActivityMini", t[t.bizWxShortLinkMini = 6] = "bizWxShortLinkMini", t[t.bizWxMaterialMini = 7] = "bizWxMaterialMini", t[t.bizUUID = 8] = "bizUUID", t[t.bizMax = 9] = "bizMax";
  })(e.SubDomain || (e.SubDomain = {}));
})(Kt || (Kt = {}));
class Bn {
  constructor() {
    this.jsSDK = (t, n) => {
      const r = n && n.header ? { ...n.header, "x-api-version": "v1.0.20240515165432767" } : { "x-api-version": "v1.0.20240515165432767" };
      return ke({
        optionName: "go-open-ecosystem-center.goopenecosystemcenter.UserAuthorizerService.JsSDK",
        params: t,
        extra: {
          application_name: "go-open-ecosystem-center",
          service_name: "UserAuthorizerService",
          method_name: "JsSDK",
          protobuf_version: "v1.0.20240515165432767",
          res_type_name: "JsSDKResponse",
          ...n,
          header: r
        }
      });
    }, this.getUserIdentity = (t, n) => {
      const r = n && n.header ? { ...n.header, "x-api-version": "v1.0.20240515165432767" } : { "x-api-version": "v1.0.20240515165432767" };
      return ke({
        optionName: "go-open-ecosystem-center.goopenecosystemcenter.UserAuthorizerService.GetUserIdentity",
        params: t,
        extra: {
          application_name: "go-open-ecosystem-center",
          service_name: "UserAuthorizerService",
          method_name: "GetUserIdentity",
          protobuf_version: "v1.0.20240515165432767",
          res_type_name: "GetUserIdentityResponse",
          ...n,
          header: r
        }
      });
    }, this.userIdentityDetail = (t, n) => {
      const r = n && n.header ? { ...n.header, "x-api-version": "v1.0.20240516100100672" } : { "x-api-version": "v1.0.20240516100100672" };
      return ke({
        optionName: "go-open-ecosystem-center.goopenecosystemcenter.UserAuthorizerService.UserIdentityDetail",
        params: t,
        extra: {
          application_name: "go-open-ecosystem-center",
          service_name: "UserAuthorizerService",
          method_name: "UserIdentityDetail",
          protobuf_version: "v1.0.20240516100100672",
          res_type_name: "UserIdentityDetailResponse",
          ...n,
          header: r
        }
      });
    }, this.completeUserIdentity = (t, n) => {
      const r = n && n.header ? { ...n.header, "x-api-version": "v1.0.20240515165432767" } : { "x-api-version": "v1.0.20240515165432767" };
      return ke({
        optionName: "go-open-ecosystem-center.goopenecosystemcenter.UserAuthorizerService.CompleteUserIdentity",
        params: t,
        extra: {
          application_name: "go-open-ecosystem-center",
          service_name: "UserAuthorizerService",
          method_name: "CompleteUserIdentity",
          protobuf_version: "v1.0.20240515165432767",
          res_type_name: "CompleteUserIdentityResponse",
          ...n,
          header: r
        }
      });
    };
  }
}
const Dn = new Bn(), cr = () => typeof window < "u", he = cr() && /wxwork/i.test(window.navigator.userAgent), lr = cr() && /micromessenger/i.test(window.navigator.userAgent);
var sr, ur;
const bt = window.location.search || ((ur = (sr = window.location.hash) == null ? void 0 : sr.split("?")) == null ? void 0 : ur[1]) || "", ft = () => new URLSearchParams(bt).get("adId") || "", Hn = () => new URLSearchParams(bt).get("scope") || "", _n = () => new URLSearchParams(bt).get("companyId") || "", On = () => {
  let e = "";
  const { location: { hash: t, href: n } } = window;
  return t ? e = n.split("#")[0] : e = n, e;
}, Ln = (e) => {
  let t = "";
  return ["tiktok-mini"].includes(e) && (t = "tiktok-platform"), ["wx-mini", "wx-official"].includes(e) && (t = "wx-platform"), !["h5", "tiktok-mini"].includes(e) && he && (t = "qw-platform"), t;
}, Ci = (e = ["code", "appId", "appid", "state"]) => {
  var u;
  const t = [];
  new URLSearchParams(window.location.search).forEach((s, l) => {
    t.push({ key: l, value: s });
  });
  const n = [];
  new URLSearchParams((u = window.location.hash.split("?")) == null ? void 0 : u[1]).forEach((s, l) => {
    n.push({ key: l, value: s });
  }), e.forEach((s) => {
    t.forEach((l, T) => {
      l.key === s && t.splice(T, 1);
    }), n.forEach((l, T) => {
      l.key === s && n.splice(T, 1);
    });
  });
  let r = window.location.origin + window.location.pathname;
  if (t.length && (r += "?" + t.map((s) => `${s.key}=${s.value}`).join("&")), n.length) {
    const s = window.location.hash.split("?")[0];
    r += s + "?" + n.map((l) => `${l.key}=${l.value}`).join("&");
  }
  return r;
}, Nn = async (e) => {
  try {
    const { companyId: t, platform: n, subDomain: r } = e, u = {
      adId: ft(),
      signURL: On(),
      subDomain: r,
      companyId: t,
      platform: n
    };
    return await Dn.jsSDK(u);
  } catch (t) {
    return console.error("js sdk!", t.message), null;
  }
}, jt = {
  wx: "//res.wx.qq.com/open/js/jweixin-1.2.0.js",
  qw: "//open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js"
}, Rn = (e) => {
  let t = [];
  return e.length > 0 ? t = e : he ? t.concat([jt.qw]) : t.concat([jt.wx]);
}, Vn = (e) => new Promise((t, n) => {
  let r = "";
  const u = e.split("/js/")[1];
  console.log(`当前sdk版本为：${u}`), e = e.replaceAll("https:", ""), e = e.replaceAll("http:", ""), r = window.location.protocol + e;
  const s = document.createElement("script");
  s.readyState ? s.onreadystatechange = () => {
    (s.readyState === "loaded" || s.readyState === "complete") && (s.onreadystatechange = null, window.wx && window.wx.ready ? t(!0) : n(!1));
  } : s.onload = () => {
    window.wx && window.wx.ready ? t(!0) : n(!1);
  }, s.setAttribute("src", r), s.setAttribute("data-namespace", `${r}-${(/* @__PURE__ */ new Date()).getTime()}`), document.body ? document.body.appendChild(s) : document.head.appendChild(s);
}), Fn = (e) => new Promise(async (t, n) => {
  const { wx: r } = window;
  r && r.ready && t(!0);
  let u = Rn(e);
  if (u) {
    const s = [];
    for (let T = 0; T < u.length; T++)
      s.push(Vn(u[T]));
    const l = await Promise.all(s);
    for (let T = 0; T < l.length; T++)
      l[T] || n(!1);
    t(!0);
  } else
    n(!1);
});
class Bi {
  constructor(t) {
    this.isInit = !1, this.wxConfig = t;
  }
  async init() {
    try {
      if (!he && !lr)
        return;
      const { hostList: t } = this.wxConfig;
      if (!await Fn(t != null && t.length ? t : []))
        return console.error("error jssdk mount element");
      const r = await this.wxOfficialLogin();
      if (!r)
        return !1;
      const u = r.list || [];
      return console.log("init browser SDK", u), this.isInit = await this.setBrowserConfig(u), this.isInit;
    } catch (t) {
      return console.error("init!", t.message), t;
    }
  }
  // 设置菜单
  async setMenuConfig(t, n) {
    this.isInit || await this.init();
    const { wx: r } = window;
    n === "show" ? r.showMenuItems({
      menuList: t
    }) : r.hideMenuItems({
      menuList: t
    });
  }
  // 设置分享
  async setShareConfig(t, n = () => {
  }) {
    this.isInit || await this.init(), he ? this.setQwShare(t, n) : this.setWxShare(t, n);
  }
  async setWxShare(t, n = () => {
  }) {
    const { wx: r } = window;
    if (r != null && r.onMenuShareAppMessage && (r != null && r.onMenuShareTimeline)) {
      r.onMenuShareAppMessage({
        ...t,
        success() {
          n({ success: !0, type: "friend" }), console.log("个微-旧版分享给朋友：success");
        },
        fail(u) {
          console.log("个微-旧版分享给朋友：fail", u);
        },
        cancel() {
          n({ success: !1, type: "friend" });
        }
      }), r.onMenuShareTimeline({
        ...t,
        success() {
          n({ success: !0, type: "friendCircle" }), console.log("个微-旧版分享到朋友圈：success");
        },
        fail(u) {
          console.log("个微-旧版分享到朋友圈：fail", u);
        },
        cancel() {
          n({ success: !1, type: "friendCircle" });
        }
      }), console.log("个微分享-执行了旧版方法");
      return;
    }
    (r != null && r.updateAppMessageShareData || r != null && r.updateTimelineShareData) && (r == null || r.updateAppMessageShareData({
      ...t,
      success() {
        console.log("个微-新版分享给朋友：success");
      },
      fail(u) {
        console.log("个微-新版分享给朋友：fail", u);
      }
    }), r == null || r.updateTimelineShareData({
      ...t,
      success() {
        console.log("个微-新版分享到朋友圈：success");
      },
      fail(u) {
        console.log("个微-新版分享到朋友圈：fail", u);
      }
    }), console.log("个微分享-执行了新版方法"));
  }
  async setQwShare(t, n = () => {
  }) {
    const { wx: r } = window;
    r.onMenuShareAppMessage({
      ...t,
      success() {
        n({ success: !0, type: "friend" }), console.log("企微-分享给朋友：success");
      },
      fail(u) {
        console.log("企微-分享给朋友：fail", u);
      },
      cancel() {
        n({ success: !1, type: "friend" });
      }
    }), r.onMenuShareWechat({
      ...t,
      success() {
        n({ success: !0, type: "friend" }), console.log("企微-分享给朋友：success");
      },
      fail(u) {
        console.log("企微-分享给朋友：fail", u);
      },
      cancel() {
        n({ success: !1, type: "friend" });
      }
    }), r.onMenuShareTimeline({
      ...t,
      success() {
        n({ success: !0, type: "friendCircle" }), console.log("企微-分享到朋友圈：success");
      },
      fail(u) {
        console.log("企微-分享到朋友圈：fail", u);
      },
      cancel() {
        n({ success: !1, type: "friendCircle" });
      }
    });
  }
  // 授权API，返回code(appId)
  async wxOfficialLogin() {
    try {
      const { account: t } = this.wxConfig, n = {
        platform: he ? "qw-platform" : "wx-platform",
        companyId: t
      };
      !he && (n.subDomain = "bizWxOfficial");
      const r = await Nn(n);
      return r && r.code === "0" ? { list: r.data.list } : null;
    } catch (t) {
      return console.error("wx official login!", t.message), null;
    }
  }
  async setBrowserConfig(t) {
    return new Promise(async (n) => {
      const {
        account: r,
        subDomain: u,
        config: { agentId: s, corpId: l, debug: T } = {},
        openTagList: p,
        isEach: v = !1,
        jsApiList: g,
        jsMenuList: i,
        jsApis: h,
        jsMenus: m
      } = this.wxConfig, G = {
        platformType: Ln("wx-official"),
        appType: "wx-official",
        query: {
          agentId: s,
          corpId: l,
          companyId: r,
          subDomain: u,
          debug: T
        },
        openTagList: p != null && p.length ? p : [],
        isEach: v,
        jsApiList: g != null && g.length ? g : [],
        jsApis: h != null && h.length ? h : [],
        jsMenuList: i != null && i.length ? i : [],
        jsMenus: m != null && m.length ? m : [],
        filterList: t
      };
      console.log("set borwser config:", G), await En(G).then(() => {
        n(!0);
      }).catch((D) => {
        console.log("res borwser:", D), n(!1);
      });
    });
  }
}
var dt = {
  Platform: {
    SID: "sid"
  }
}, de = {
  WebSocket: "global-event-web-socket",
  UserAuth: "global-event-user-auth",
  PresentEvent: "global-event-present-event",
  PresentEventApp: "global-event-present-event-app",
  InitCoreSdk: "global-event-init-core-sdk",
  ShowLoading: "global-event-show-loading",
  HiddenLoading: "global-event-hide-loading",
  HiddenComponent: "global-event-hide-component",
  ReloadMicroPage: "global-event-reload-micro-page"
}, ce = {
  Menu: "global-data-menu",
  Access: "global-data-access",
  OEM: "global-data-oem",
  Components: "global-data-components",
  SwitchConfig: "global-data-switch-config",
  InitSdk: "global-data-init-sdk",
  TenantType: "global-data-tenant-type"
};
function xn() {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  function n(h) {
    return !!h;
  }
  function r(h) {
    var m = typeof h == "function";
    return m || console.error("observer must be a function"), m;
  }
  function u(h, m) {
    n(h) && (e.get(h) || []).forEach(function(G) {
      return G(h, m);
    });
  }
  function s(h, m, G) {
    if (G === void 0 && (G = !0), !!n(h)) {
      var D = xt(m);
      t.set(h, D), G && u(h, m);
    }
  }
  function l(h, m) {
    return m === void 0 && (m = !0), m ? xt(t.get(h)) : t.get(h);
  }
  function T(h, m) {
    if (!(!r(m) || !n(h))) {
      var G = e.get(h) || [];
      G.some(function(D) {
        return D === m;
      }) || (G.push(m), e.set(h, G));
    }
  }
  function p(h, m) {
    if (!(!r(m) || !n(h))) {
      var G = e.get(h) || [];
      if (G.length) {
        var D = G.findIndex(function(O) {
          return O === m;
        });
        D !== -1 && G.splice(D, 1);
      }
    }
  }
  function v(h) {
    n(h) && e.delete(h);
  }
  function g(h, m) {
    if (!(!r(m) || !n(h))) {
      var G = function(D, O) {
        m(D, O), p(D, G);
      };
      T(h, G);
    }
  }
  function i() {
    console.log("===data-bus:observerMap===", e), console.log("===data-bus:sharedData===", t);
  }
  return { on: T, off: p, offData: v, once: g, emitData: s, getData: l, log: i };
}
function pe() {
  return window.__ITIMO_DATA_SHARE || (window.__ITIMO_DATA_SHARE = xn()), window.__ITIMO_DATA_SHARE;
}
var Q = function() {
  return Q = Object.assign || function(t) {
    for (var n, r = 1, u = arguments.length; r < u; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Q.apply(this, arguments);
};
function te(e, t, n, r) {
  function u(s) {
    return s instanceof n ? s : new n(function(l) {
      l(s);
    });
  }
  return new (n || (n = Promise))(function(s, l) {
    function T(g) {
      try {
        v(r.next(g));
      } catch (i) {
        l(i);
      }
    }
    function p(g) {
      try {
        v(r.throw(g));
      } catch (i) {
        l(i);
      }
    }
    function v(g) {
      g.done ? s(g.value) : u(g.value).then(T, p);
    }
    v((r = r.apply(e, [])).next());
  });
}
function re(e, t) {
  var n = { label: 0, sent: function() {
    if (s[0] & 1)
      throw s[1];
    return s[1];
  }, trys: [], ops: [] }, r, u, s, l;
  return l = { next: T(0), throw: T(1), return: T(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function T(v) {
    return function(g) {
      return p([v, g]);
    };
  }
  function p(v) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, u && (s = v[0] & 2 ? u.return : v[0] ? u.throw || ((s = u.return) && s.call(u), 0) : u.next) && !(s = s.call(u, v[1])).done)
          return s;
        switch (u = 0, s && (v = [v[0] & 2, s.value]), v[0]) {
          case 0:
          case 1:
            s = v;
            break;
          case 4:
            return n.label++, { value: v[1], done: !1 };
          case 5:
            n.label++, u = v[1], v = [0];
            continue;
          case 7:
            v = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (s = n.trys, !(s = s.length > 0 && s[s.length - 1]) && (v[0] === 6 || v[0] === 2)) {
              n = 0;
              continue;
            }
            if (v[0] === 3 && (!s || v[1] > s[0] && v[1] < s[3])) {
              n.label = v[1];
              break;
            }
            if (v[0] === 6 && n.label < s[1]) {
              n.label = s[1], s = v;
              break;
            }
            if (s && n.label < s[2]) {
              n.label = s[2], n.ops.push(v);
              break;
            }
            s[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        v = t.call(e, n);
      } catch (g) {
        v = [6, g], u = 0;
      } finally {
        r = s = 0;
      }
    if (v[0] & 5)
      throw v[1];
    return { value: v[0] ? v[1] : void 0, done: !0 };
  }
}
function Ge(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, u = t.length, s; r < u; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function oe(e, t, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}
function Pe(e, t, n, r, u) {
  if (typeof t == "function" ? e !== t || !u : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, n), n;
}
var ge, Me, Un = function() {
  function e() {
    ge.set(this, []), Me.set(this, pe());
  }
  return Object.defineProperty(e.prototype, "setGlobalState", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t, n, r) {
      r === void 0 && (r = !0), oe(this, Me, "f").emitData(t, n, r);
    }
  }), Object.defineProperty(e.prototype, "onGlobalState", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t, n) {
      var r = this, u = function(l, T) {
        n(T);
      };
      oe(this, Me, "f").on(t, u);
      var s = function() {
        oe(r, Me, "f").off(t, u);
      };
      return oe(this, ge, "f").push(s), s;
    }
  }), Object.defineProperty(e.prototype, "getGlobalState", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      return oe(this, Me, "f").getData(t, !0);
    }
  }), Object.defineProperty(e.prototype, "destroy", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      oe(this, ge, "f").forEach(function(t) {
        return t();
      }), Pe(this, ge, []);
    }
  }), Object.defineProperty(e.prototype, "log", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      console.log("global state======", oe(this, ge, "f"));
    }
  }), e;
}();
ge = /* @__PURE__ */ new WeakMap(), Me = /* @__PURE__ */ new WeakMap();
var kn = new Un();
function Ie() {
  function e(l) {
    return !!l;
  }
  function t(l) {
    var T = typeof l == "function";
    return T || console.error("observer must be a function"), T;
  }
  function n(l, T) {
    T === void 0 && (T = {}), e(l) && window.dispatchEvent(new CustomEvent(l, { detail: T }));
  }
  function r(l, T, p) {
    !t(T) || !e(l) || window.addEventListener(l, T, p);
  }
  function u(l, T) {
    return r(l, T, { once: !0 });
  }
  function s(l, T, p) {
    !t(T) || !e(l) || window.removeEventListener(l, T, p);
  }
  return { on: r, off: s, once: u, dispatch: n };
}
var Wn = Ie();
function fr() {
  var e = {}, t = /([^?=&]+)=([^?=&]+)/g, n = location.href.match(t);
  return n == null || n.forEach(function(r) {
    var u = r.split("="), s = u[0], l = u[1];
    e[s] = l;
  }), e;
}
function Xn(e) {
  return e ? Object.entries(e).map(function(t) {
    var n = t[0], r = t[1];
    return "".concat(n, "=").concat(r);
  }).join("&") : "";
}
function Kn(e, t) {
  var n = t.path, r = t.query, u = location.origin, s = Xn(r), l = "".concat(u).concat(n);
  s && (l += "?" + s), e === "push" ? location.href = l : location.replace(l);
}
function Qt(e) {
  return function(t) {
    return Kn(e, t);
  };
}
var dr = [Qt("push"), Qt("replace")], jn = dr[0], Qn = dr[1], Tr = {
  push: jn,
  replace: Qn
};
function zn() {
  return process.env.NODE_ENV === "development";
}
function zt(e, t) {
  t === void 0 && (t = 0), setTimeout(function() {
    e();
  }, t);
}
function Yn(e) {
  return Object.prototype.toString.apply(e) === "[object Object]";
}
/*! js-cookie v3.0.1 | MIT */
function We(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var Jn = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
function Tt(e, t) {
  function n(u, s, l) {
    if (!(typeof document > "u")) {
      l = We({}, t, l), typeof l.expires == "number" && (l.expires = new Date(Date.now() + l.expires * 864e5)), l.expires && (l.expires = l.expires.toUTCString()), u = encodeURIComponent(u).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var T = "";
      for (var p in l)
        l[p] && (T += "; " + p, l[p] !== !0 && (T += "=" + l[p].split(";")[0]));
      return document.cookie = u + "=" + e.write(s, u) + T;
    }
  }
  function r(u) {
    if (!(typeof document > "u" || arguments.length && !u)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], l = {}, T = 0; T < s.length; T++) {
        var p = s[T].split("="), v = p.slice(1).join("=");
        try {
          var g = decodeURIComponent(p[0]);
          if (l[g] = e.read(v, g), u === g)
            break;
        } catch {
        }
      }
      return u ? l[u] : l;
    }
  }
  return Object.create({
    set: n,
    get: r,
    remove: function(u, s) {
      n(u, "", We({}, s, {
        expires: -1
      }));
    },
    withAttributes: function(u) {
      return Tt(this.converter, We({}, this.attributes, u));
    },
    withConverter: function(u) {
      return Tt(We({}, this.converter, u), this.attributes);
    }
  }, {
    attributes: { value: Object.freeze(t) },
    converter: { value: Object.freeze(e) }
  });
}
var at = Tt(Jn, { path: "/" });
function se(e, t) {
  return e ? "".concat(e, "-").concat(t) : t;
}
function qn(e) {
  var t = function(u, s, l) {
    return at.set(se(e, u), s, l);
  };
  function n(u) {
    return at.get(se(e, u));
  }
  var r = function(u, s) {
    return at.remove(se(e, u), s);
  };
  return {
    setCookie: t,
    getCookie: n,
    removeCookie: r
  };
}
function Sr(e) {
  function t(s, l) {
    var T = typeof l;
    if (T === "function" || T === "symbol")
      return console.error("LocalStorage.setItem value cannot be a function or a symbol"), !1;
    try {
      return Yn(l) ? window.localStorage.setItem(se(e, s), JSON.stringify(l)) : window.localStorage.setItem(se(e, s), l + ""), !0;
    } catch (p) {
      console.error(p);
    }
    return !1;
  }
  function n(s) {
    var l = se(e, s);
    return window.localStorage.getItem(l);
  }
  function r(s) {
    var l = se(e, s), T = window.localStorage.getItem(l);
    if (T)
      try {
        return JSON.parse(T);
      } catch (p) {
        console.error(p);
        return;
      }
  }
  function u(s) {
    window.localStorage.removeItem(se(e, s));
  }
  return {
    setItem: t,
    getItem: n,
    getJSONItem: r,
    removeItem: u
  };
}
var Re = Sr("");
function $n(e) {
  function t(u, s) {
    window.sessionStorage.setItem(se(e, u), s);
  }
  function n(u) {
    return window.sessionStorage.getItem(se(e, u));
  }
  function r(u) {
    window.sessionStorage.removeItem(se(e, u));
  }
  return {
    setSession: t,
    getSession: n,
    removeSession: r
  };
}
function Zn(e) {
  return Q(Q(Q({}, Sr(e)), qn(e)), $n(e));
}
function hr(e) {
  return Zn(e);
}
var eo = hr("_DEFAULT_"), be = ["crm", "platform", "growth", "mall", "cs"].reduce(function(e, t) {
  return e[t] = hr(t), e;
}, eo), Ee = {
  Platform: {
    User: "user",
    Config: "config"
  }
};
function to(e) {
  be.platform.setCookie(dt.Platform.SID, e);
}
function pt(e) {
  return e === "pc" ? "qw-user" : "user";
}
function Ye(e) {
  var t;
  return e === void 0 && (e = "pc"), e = e == "pc" ? "pc" : "qw", e === "pc" ? be.platform.getCookie(dt.Platform.SID) : be.platform.getCookie(dt.Platform.SID) || ((t = Re.getJSONItem(pt(e))) === null || t === void 0 ? void 0 : t.sid);
}
function ro(e, t) {
  t === void 0 && (t = "pc"), e != null && e.sid && (to(e.sid), be.platform.setItem(Ee.Platform.User, e), Re.setItem(pt(t), e));
}
function br(e) {
  return e === void 0 && (e = "pc"), be.platform.getJSONItem(Ee.Platform.User) || Re.getJSONItem(pt(e)) || {};
}
function no(e) {
  var t = e.corpId, n = e.corpid, r = e.agentId, u = e.isSideMenu;
  if ((t || n) && r) {
    var s = {
      corpId: t || n,
      agentId: r,
      isSideMenu: u
    };
    be.platform.setItem(Ee.Platform.Config, s), Re.setItem(Ee.Platform.Config, s);
  } else
    console.error("set agent config error");
}
function oo(e) {
  return (e == null ? void 0 : e.corpId) && (e == null ? void 0 : e.agentId);
}
function pr(e) {
  e === void 0 && (e = "pc");
  var t = fr(), n = e === "pc" ? be.platform.getJSONItem(Ee.Platform.Config) : Re.getJSONItem(Ee.Platform.Config);
  return oo(t) ? t : n;
}
var Xe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ke(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var vr = { exports: {} };
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(e, t) {
  (function(n) {
    e.exports = n();
  })(function() {
    return function n(r, u, s) {
      function l(v, g) {
        if (!u[v]) {
          if (!r[v]) {
            var i = typeof Ke == "function" && Ke;
            if (!g && i)
              return i(v, !0);
            if (T)
              return T(v, !0);
            var h = new Error("Cannot find module '" + v + "'");
            throw h.code = "MODULE_NOT_FOUND", h;
          }
          var m = u[v] = { exports: {} };
          r[v][0].call(m.exports, function(G) {
            var D = r[v][1][G];
            return l(D || G);
          }, m, m.exports, n, r, u, s);
        }
        return u[v].exports;
      }
      for (var T = typeof Ke == "function" && Ke, p = 0; p < s.length; p++)
        l(s[p]);
      return l;
    }({ 1: [function(n, r, u) {
      (function(s) {
        var l = s.MutationObserver || s.WebKitMutationObserver, T;
        if (l) {
          var p = 0, v = new l(G), g = s.document.createTextNode("");
          v.observe(g, {
            characterData: !0
          }), T = function() {
            g.data = p = ++p % 2;
          };
        } else if (!s.setImmediate && typeof s.MessageChannel < "u") {
          var i = new s.MessageChannel();
          i.port1.onmessage = G, T = function() {
            i.port2.postMessage(0);
          };
        } else
          "document" in s && "onreadystatechange" in s.document.createElement("script") ? T = function() {
            var O = s.document.createElement("script");
            O.onreadystatechange = function() {
              G(), O.onreadystatechange = null, O.parentNode.removeChild(O), O = null;
            }, s.document.documentElement.appendChild(O);
          } : T = function() {
            setTimeout(G, 0);
          };
        var h, m = [];
        function G() {
          h = !0;
          for (var O, U, N = m.length; N; ) {
            for (U = m, m = [], O = -1; ++O < N; )
              U[O]();
            N = m.length;
          }
          h = !1;
        }
        r.exports = D;
        function D(O) {
          m.push(O) === 1 && !h && T();
        }
      }).call(this, typeof Xe < "u" ? Xe : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 2: [function(n, r, u) {
      var s = n(1);
      function l() {
      }
      var T = {}, p = ["REJECTED"], v = ["FULFILLED"], g = ["PENDING"];
      r.exports = i;
      function i(B) {
        if (typeof B != "function")
          throw new TypeError("resolver must be a function");
        this.state = g, this.queue = [], this.outcome = void 0, B !== l && D(this, B);
      }
      i.prototype.catch = function(B) {
        return this.then(null, B);
      }, i.prototype.then = function(B, R) {
        if (typeof B != "function" && this.state === v || typeof R != "function" && this.state === p)
          return this;
        var L = new this.constructor(l);
        if (this.state !== g) {
          var x = this.state === v ? B : R;
          m(L, x, this.outcome);
        } else
          this.queue.push(new h(L, B, R));
        return L;
      };
      function h(B, R, L) {
        this.promise = B, typeof R == "function" && (this.onFulfilled = R, this.callFulfilled = this.otherCallFulfilled), typeof L == "function" && (this.onRejected = L, this.callRejected = this.otherCallRejected);
      }
      h.prototype.callFulfilled = function(B) {
        T.resolve(this.promise, B);
      }, h.prototype.otherCallFulfilled = function(B) {
        m(this.promise, this.onFulfilled, B);
      }, h.prototype.callRejected = function(B) {
        T.reject(this.promise, B);
      }, h.prototype.otherCallRejected = function(B) {
        m(this.promise, this.onRejected, B);
      };
      function m(B, R, L) {
        s(function() {
          var x;
          try {
            x = R(L);
          } catch (K) {
            return T.reject(B, K);
          }
          x === B ? T.reject(B, new TypeError("Cannot resolve promise with itself")) : T.resolve(B, x);
        });
      }
      T.resolve = function(B, R) {
        var L = O(G, R);
        if (L.status === "error")
          return T.reject(B, L.value);
        var x = L.value;
        if (x)
          D(B, x);
        else {
          B.state = v, B.outcome = R;
          for (var K = -1, P = B.queue.length; ++K < P; )
            B.queue[K].callFulfilled(R);
        }
        return B;
      }, T.reject = function(B, R) {
        B.state = p, B.outcome = R;
        for (var L = -1, x = B.queue.length; ++L < x; )
          B.queue[L].callRejected(R);
        return B;
      };
      function G(B) {
        var R = B && B.then;
        if (B && (typeof B == "object" || typeof B == "function") && typeof R == "function")
          return function() {
            R.apply(B, arguments);
          };
      }
      function D(B, R) {
        var L = !1;
        function x(I) {
          L || (L = !0, T.reject(B, I));
        }
        function K(I) {
          L || (L = !0, T.resolve(B, I));
        }
        function P() {
          R(K, x);
        }
        var b = O(P);
        b.status === "error" && x(b.value);
      }
      function O(B, R) {
        var L = {};
        try {
          L.value = B(R), L.status = "success";
        } catch (x) {
          L.status = "error", L.value = x;
        }
        return L;
      }
      i.resolve = U;
      function U(B) {
        return B instanceof this ? B : T.resolve(new this(l), B);
      }
      i.reject = N;
      function N(B) {
        var R = new this(l);
        return T.reject(R, B);
      }
      i.all = Z;
      function Z(B) {
        var R = this;
        if (Object.prototype.toString.call(B) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var L = B.length, x = !1;
        if (!L)
          return this.resolve([]);
        for (var K = new Array(L), P = 0, b = -1, I = new this(l); ++b < L; )
          H(B[b], b);
        return I;
        function H(C, F) {
          R.resolve(C).then(j, function(z) {
            x || (x = !0, T.reject(I, z));
          });
          function j(z) {
            K[F] = z, ++P === L && !x && (x = !0, T.resolve(I, K));
          }
        }
      }
      i.race = Y;
      function Y(B) {
        var R = this;
        if (Object.prototype.toString.call(B) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var L = B.length, x = !1;
        if (!L)
          return this.resolve([]);
        for (var K = -1, P = new this(l); ++K < L; )
          b(B[K]);
        return P;
        function b(I) {
          R.resolve(I).then(function(H) {
            x || (x = !0, T.resolve(P, H));
          }, function(H) {
            x || (x = !0, T.reject(P, H));
          });
        }
      }
    }, { 1: 1 }], 3: [function(n, r, u) {
      (function(s) {
        typeof s.Promise != "function" && (s.Promise = n(2));
      }).call(this, typeof Xe < "u" ? Xe : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { 2: 2 }], 4: [function(n, r, u) {
      var s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
        return typeof o;
      } : function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      };
      function l(o, c) {
        if (!(o instanceof c))
          throw new TypeError("Cannot call a class as a function");
      }
      function T() {
        try {
          if (typeof indexedDB < "u")
            return indexedDB;
          if (typeof webkitIndexedDB < "u")
            return webkitIndexedDB;
          if (typeof mozIndexedDB < "u")
            return mozIndexedDB;
          if (typeof OIndexedDB < "u")
            return OIndexedDB;
          if (typeof msIndexedDB < "u")
            return msIndexedDB;
        } catch {
          return;
        }
      }
      var p = T();
      function v() {
        try {
          if (!p || !p.open)
            return !1;
          var o = typeof openDatabase < "u" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform), c = typeof fetch == "function" && fetch.toString().indexOf("[native code") !== -1;
          return (!o || c) && typeof indexedDB < "u" && typeof IDBKeyRange < "u";
        } catch {
          return !1;
        }
      }
      function g(o, c) {
        o = o || [], c = c || {};
        try {
          return new Blob(o, c);
        } catch (f) {
          if (f.name !== "TypeError")
            throw f;
          for (var a = typeof BlobBuilder < "u" ? BlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : WebKitBlobBuilder, d = new a(), S = 0; S < o.length; S += 1)
            d.append(o[S]);
          return d.getBlob(c.type);
        }
      }
      typeof Promise > "u" && n(3);
      var i = Promise;
      function h(o, c) {
        c && o.then(function(a) {
          c(null, a);
        }, function(a) {
          c(a);
        });
      }
      function m(o, c, a) {
        typeof c == "function" && o.then(c), typeof a == "function" && o.catch(a);
      }
      function G(o) {
        return typeof o != "string" && (console.warn(o + " used as a key, but it is not a string."), o = String(o)), o;
      }
      function D() {
        if (arguments.length && typeof arguments[arguments.length - 1] == "function")
          return arguments[arguments.length - 1];
      }
      var O = "local-forage-detect-blob-support", U = void 0, N = {}, Z = Object.prototype.toString, Y = "readonly", B = "readwrite";
      function R(o) {
        for (var c = o.length, a = new ArrayBuffer(c), d = new Uint8Array(a), S = 0; S < c; S++)
          d[S] = o.charCodeAt(S);
        return a;
      }
      function L(o) {
        return new i(function(c) {
          var a = o.transaction(O, B), d = g([""]);
          a.objectStore(O).put(d, "key"), a.onabort = function(S) {
            S.preventDefault(), S.stopPropagation(), c(!1);
          }, a.oncomplete = function() {
            var S = navigator.userAgent.match(/Chrome\/(\d+)/), f = navigator.userAgent.match(/Edge\//);
            c(f || !S || parseInt(S[1], 10) >= 43);
          };
        }).catch(function() {
          return !1;
        });
      }
      function x(o) {
        return typeof U == "boolean" ? i.resolve(U) : L(o).then(function(c) {
          return U = c, U;
        });
      }
      function K(o) {
        var c = N[o.name], a = {};
        a.promise = new i(function(d, S) {
          a.resolve = d, a.reject = S;
        }), c.deferredOperations.push(a), c.dbReady ? c.dbReady = c.dbReady.then(function() {
          return a.promise;
        }) : c.dbReady = a.promise;
      }
      function P(o) {
        var c = N[o.name], a = c.deferredOperations.pop();
        if (a)
          return a.resolve(), a.promise;
      }
      function b(o, c) {
        var a = N[o.name], d = a.deferredOperations.pop();
        if (d)
          return d.reject(c), d.promise;
      }
      function I(o, c) {
        return new i(function(a, d) {
          if (N[o.name] = N[o.name] || Be(), o.db)
            if (c)
              K(o), o.db.close();
            else
              return a(o.db);
          var S = [o.name];
          c && S.push(o.version);
          var f = p.open.apply(p, S);
          c && (f.onupgradeneeded = function(A) {
            var M = f.result;
            try {
              M.createObjectStore(o.storeName), A.oldVersion <= 1 && M.createObjectStore(O);
            } catch (w) {
              if (w.name === "ConstraintError")
                console.warn('The database "' + o.name + '" has been upgraded from version ' + A.oldVersion + " to version " + A.newVersion + ', but the storage "' + o.storeName + '" already exists.');
              else
                throw w;
            }
          }), f.onerror = function(A) {
            A.preventDefault(), d(f.error);
          }, f.onsuccess = function() {
            var A = f.result;
            A.onversionchange = function(M) {
              M.target.close();
            }, a(A), P(o);
          };
        });
      }
      function H(o) {
        return I(o, !1);
      }
      function C(o) {
        return I(o, !0);
      }
      function F(o, c) {
        if (!o.db)
          return !0;
        var a = !o.db.objectStoreNames.contains(o.storeName), d = o.version < o.db.version, S = o.version > o.db.version;
        if (d && (o.version !== c && console.warn('The database "' + o.name + `" can't be downgraded from version ` + o.db.version + " to version " + o.version + "."), o.version = o.db.version), S || a) {
          if (a) {
            var f = o.db.version + 1;
            f > o.version && (o.version = f);
          }
          return !0;
        }
        return !1;
      }
      function j(o) {
        return new i(function(c, a) {
          var d = new FileReader();
          d.onerror = a, d.onloadend = function(S) {
            var f = btoa(S.target.result || "");
            c({
              __local_forage_encoded_blob: !0,
              data: f,
              type: o.type
            });
          }, d.readAsBinaryString(o);
        });
      }
      function z(o) {
        var c = R(atob(o.data));
        return g([c], { type: o.type });
      }
      function ie(o) {
        return o && o.__local_forage_encoded_blob;
      }
      function W(o) {
        var c = this, a = c._initReady().then(function() {
          var d = N[c._dbInfo.name];
          if (d && d.dbReady)
            return d.dbReady;
        });
        return m(a, o, o), a;
      }
      function ne(o) {
        K(o);
        for (var c = N[o.name], a = c.forages, d = 0; d < a.length; d++) {
          var S = a[d];
          S._dbInfo.db && (S._dbInfo.db.close(), S._dbInfo.db = null);
        }
        return o.db = null, H(o).then(function(f) {
          return o.db = f, F(o) ? C(o) : f;
        }).then(function(f) {
          o.db = c.db = f;
          for (var A = 0; A < a.length; A++)
            a[A]._dbInfo.db = f;
        }).catch(function(f) {
          throw b(o, f), f;
        });
      }
      function q(o, c, a, d) {
        d === void 0 && (d = 1);
        try {
          var S = o.db.transaction(o.storeName, c);
          a(null, S);
        } catch (f) {
          if (d > 0 && (!o.db || f.name === "InvalidStateError" || f.name === "NotFoundError"))
            return i.resolve().then(function() {
              if (!o.db || f.name === "NotFoundError" && !o.db.objectStoreNames.contains(o.storeName) && o.version <= o.db.version)
                return o.db && (o.version = o.db.version + 1), C(o);
            }).then(function() {
              return ne(o).then(function() {
                q(o, c, a, d - 1);
              });
            }).catch(a);
          a(f);
        }
      }
      function Be() {
        return {
          forages: [],
          db: null,
          dbReady: null,
          deferredOperations: []
        };
      }
      function Fe(o) {
        var c = this, a = {
          db: null
        };
        if (o)
          for (var d in o)
            a[d] = o[d];
        var S = N[a.name];
        S || (S = Be(), N[a.name] = S), S.forages.push(c), c._initReady || (c._initReady = c.ready, c.ready = W);
        var f = [];
        function A() {
          return i.resolve();
        }
        for (var M = 0; M < S.forages.length; M++) {
          var w = S.forages[M];
          w !== c && f.push(w._initReady().catch(A));
        }
        var y = S.forages.slice(0);
        return i.all(f).then(function() {
          return a.db = S.db, H(a);
        }).then(function(E) {
          return a.db = E, F(a, c._defaultConfig.version) ? C(a) : E;
        }).then(function(E) {
          a.db = S.db = E, c._dbInfo = a;
          for (var _ = 0; _ < y.length; _++) {
            var V = y[_];
            V !== c && (V._dbInfo.db = a.db, V._dbInfo.version = a.version);
          }
        });
      }
      function De(o, c) {
        var a = this;
        o = G(o);
        var d = new i(function(S, f) {
          a.ready().then(function() {
            q(a._dbInfo, Y, function(A, M) {
              if (A)
                return f(A);
              try {
                var w = M.objectStore(a._dbInfo.storeName), y = w.get(o);
                y.onsuccess = function() {
                  var E = y.result;
                  E === void 0 && (E = null), ie(E) && (E = z(E)), S(E);
                }, y.onerror = function() {
                  f(y.error);
                };
              } catch (E) {
                f(E);
              }
            });
          }).catch(f);
        });
        return h(d, c), d;
      }
      function Te(o, c) {
        var a = this, d = new i(function(S, f) {
          a.ready().then(function() {
            q(a._dbInfo, Y, function(A, M) {
              if (A)
                return f(A);
              try {
                var w = M.objectStore(a._dbInfo.storeName), y = w.openCursor(), E = 1;
                y.onsuccess = function() {
                  var _ = y.result;
                  if (_) {
                    var V = _.value;
                    ie(V) && (V = z(V));
                    var k = o(V, _.key, E++);
                    k !== void 0 ? S(k) : _.continue();
                  } else
                    S();
                }, y.onerror = function() {
                  f(y.error);
                };
              } catch (_) {
                f(_);
              }
            });
          }).catch(f);
        });
        return h(d, c), d;
      }
      function Er(o, c, a) {
        var d = this;
        o = G(o);
        var S = new i(function(f, A) {
          var M;
          d.ready().then(function() {
            return M = d._dbInfo, Z.call(c) === "[object Blob]" ? x(M.db).then(function(w) {
              return w ? c : j(c);
            }) : c;
          }).then(function(w) {
            q(d._dbInfo, B, function(y, E) {
              if (y)
                return A(y);
              try {
                var _ = E.objectStore(d._dbInfo.storeName);
                w === null && (w = void 0);
                var V = _.put(w, o);
                E.oncomplete = function() {
                  w === void 0 && (w = null), f(w);
                }, E.onabort = E.onerror = function() {
                  var k = V.error ? V.error : V.transaction.error;
                  A(k);
                };
              } catch (k) {
                A(k);
              }
            });
          }).catch(A);
        });
        return h(S, a), S;
      }
      function Cr(o, c) {
        var a = this;
        o = G(o);
        var d = new i(function(S, f) {
          a.ready().then(function() {
            q(a._dbInfo, B, function(A, M) {
              if (A)
                return f(A);
              try {
                var w = M.objectStore(a._dbInfo.storeName), y = w.delete(o);
                M.oncomplete = function() {
                  S();
                }, M.onerror = function() {
                  f(y.error);
                }, M.onabort = function() {
                  var E = y.error ? y.error : y.transaction.error;
                  f(E);
                };
              } catch (E) {
                f(E);
              }
            });
          }).catch(f);
        });
        return h(d, c), d;
      }
      function Br(o) {
        var c = this, a = new i(function(d, S) {
          c.ready().then(function() {
            q(c._dbInfo, B, function(f, A) {
              if (f)
                return S(f);
              try {
                var M = A.objectStore(c._dbInfo.storeName), w = M.clear();
                A.oncomplete = function() {
                  d();
                }, A.onabort = A.onerror = function() {
                  var y = w.error ? w.error : w.transaction.error;
                  S(y);
                };
              } catch (y) {
                S(y);
              }
            });
          }).catch(S);
        });
        return h(a, o), a;
      }
      function Dr(o) {
        var c = this, a = new i(function(d, S) {
          c.ready().then(function() {
            q(c._dbInfo, Y, function(f, A) {
              if (f)
                return S(f);
              try {
                var M = A.objectStore(c._dbInfo.storeName), w = M.count();
                w.onsuccess = function() {
                  d(w.result);
                }, w.onerror = function() {
                  S(w.error);
                };
              } catch (y) {
                S(y);
              }
            });
          }).catch(S);
        });
        return h(a, o), a;
      }
      function Hr(o, c) {
        var a = this, d = new i(function(S, f) {
          if (o < 0) {
            S(null);
            return;
          }
          a.ready().then(function() {
            q(a._dbInfo, Y, function(A, M) {
              if (A)
                return f(A);
              try {
                var w = M.objectStore(a._dbInfo.storeName), y = !1, E = w.openKeyCursor();
                E.onsuccess = function() {
                  var _ = E.result;
                  if (!_) {
                    S(null);
                    return;
                  }
                  o === 0 || y ? S(_.key) : (y = !0, _.advance(o));
                }, E.onerror = function() {
                  f(E.error);
                };
              } catch (_) {
                f(_);
              }
            });
          }).catch(f);
        });
        return h(d, c), d;
      }
      function _r(o) {
        var c = this, a = new i(function(d, S) {
          c.ready().then(function() {
            q(c._dbInfo, Y, function(f, A) {
              if (f)
                return S(f);
              try {
                var M = A.objectStore(c._dbInfo.storeName), w = M.openKeyCursor(), y = [];
                w.onsuccess = function() {
                  var E = w.result;
                  if (!E) {
                    d(y);
                    return;
                  }
                  y.push(E.key), E.continue();
                }, w.onerror = function() {
                  S(w.error);
                };
              } catch (E) {
                S(E);
              }
            });
          }).catch(S);
        });
        return h(a, o), a;
      }
      function Or(o, c) {
        c = D.apply(this, arguments);
        var a = this.config();
        o = typeof o != "function" && o || {}, o.name || (o.name = o.name || a.name, o.storeName = o.storeName || a.storeName);
        var d = this, S;
        if (!o.name)
          S = i.reject("Invalid arguments");
        else {
          var f = o.name === a.name && d._dbInfo.db, A = f ? i.resolve(d._dbInfo.db) : H(o).then(function(M) {
            var w = N[o.name], y = w.forages;
            w.db = M;
            for (var E = 0; E < y.length; E++)
              y[E]._dbInfo.db = M;
            return M;
          });
          o.storeName ? S = A.then(function(M) {
            if (M.objectStoreNames.contains(o.storeName)) {
              var w = M.version + 1;
              K(o);
              var y = N[o.name], E = y.forages;
              M.close();
              for (var _ = 0; _ < E.length; _++) {
                var V = E[_];
                V._dbInfo.db = null, V._dbInfo.version = w;
              }
              var k = new i(function(X, $) {
                var J = p.open(o.name, w);
                J.onerror = function(ae) {
                  var _e = J.result;
                  _e.close(), $(ae);
                }, J.onupgradeneeded = function() {
                  var ae = J.result;
                  ae.deleteObjectStore(o.storeName);
                }, J.onsuccess = function() {
                  var ae = J.result;
                  ae.close(), X(ae);
                };
              });
              return k.then(function(X) {
                y.db = X;
                for (var $ = 0; $ < E.length; $++) {
                  var J = E[$];
                  J._dbInfo.db = X, P(J._dbInfo);
                }
              }).catch(function(X) {
                throw (b(o, X) || i.resolve()).catch(function() {
                }), X;
              });
            }
          }) : S = A.then(function(M) {
            K(o);
            var w = N[o.name], y = w.forages;
            M.close();
            for (var E = 0; E < y.length; E++) {
              var _ = y[E];
              _._dbInfo.db = null;
            }
            var V = new i(function(k, X) {
              var $ = p.deleteDatabase(o.name);
              $.onerror = function() {
                var J = $.result;
                J && J.close(), X($.error);
              }, $.onblocked = function() {
                console.warn('dropInstance blocked for database "' + o.name + '" until all open connections are closed');
              }, $.onsuccess = function() {
                var J = $.result;
                J && J.close(), k(J);
              };
            });
            return V.then(function(k) {
              w.db = k;
              for (var X = 0; X < y.length; X++) {
                var $ = y[X];
                P($._dbInfo);
              }
            }).catch(function(k) {
              throw (b(o, k) || i.resolve()).catch(function() {
              }), k;
            });
          });
        }
        return h(S, c), S;
      }
      var Lr = {
        _driver: "asyncStorage",
        _initStorage: Fe,
        _support: v(),
        iterate: Te,
        getItem: De,
        setItem: Er,
        removeItem: Cr,
        clear: Br,
        length: Dr,
        key: Hr,
        keys: _r,
        dropInstance: Or
      };
      function Nr() {
        return typeof openDatabase == "function";
      }
      var le = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Rr = "~~local_forage_type~", vt = /^~~local_forage_type~([^~]+)~/, xe = "__lfsc__:", qe = xe.length, $e = "arbf", Ze = "blob", mt = "si08", At = "ui08", Pt = "uic8", gt = "si16", Mt = "si32", wt = "ur16", yt = "ui32", Gt = "fl32", It = "fl64", Et = qe + $e.length, Ct = Object.prototype.toString;
      function Bt(o) {
        var c = o.length * 0.75, a = o.length, d, S = 0, f, A, M, w;
        o[o.length - 1] === "=" && (c--, o[o.length - 2] === "=" && c--);
        var y = new ArrayBuffer(c), E = new Uint8Array(y);
        for (d = 0; d < a; d += 4)
          f = le.indexOf(o[d]), A = le.indexOf(o[d + 1]), M = le.indexOf(o[d + 2]), w = le.indexOf(o[d + 3]), E[S++] = f << 2 | A >> 4, E[S++] = (A & 15) << 4 | M >> 2, E[S++] = (M & 3) << 6 | w & 63;
        return y;
      }
      function et(o) {
        var c = new Uint8Array(o), a = "", d;
        for (d = 0; d < c.length; d += 3)
          a += le[c[d] >> 2], a += le[(c[d] & 3) << 4 | c[d + 1] >> 4], a += le[(c[d + 1] & 15) << 2 | c[d + 2] >> 6], a += le[c[d + 2] & 63];
        return c.length % 3 === 2 ? a = a.substring(0, a.length - 1) + "=" : c.length % 3 === 1 && (a = a.substring(0, a.length - 2) + "=="), a;
      }
      function Vr(o, c) {
        var a = "";
        if (o && (a = Ct.call(o)), o && (a === "[object ArrayBuffer]" || o.buffer && Ct.call(o.buffer) === "[object ArrayBuffer]")) {
          var d, S = xe;
          o instanceof ArrayBuffer ? (d = o, S += $e) : (d = o.buffer, a === "[object Int8Array]" ? S += mt : a === "[object Uint8Array]" ? S += At : a === "[object Uint8ClampedArray]" ? S += Pt : a === "[object Int16Array]" ? S += gt : a === "[object Uint16Array]" ? S += wt : a === "[object Int32Array]" ? S += Mt : a === "[object Uint32Array]" ? S += yt : a === "[object Float32Array]" ? S += Gt : a === "[object Float64Array]" ? S += It : c(new Error("Failed to get type for BinaryArray"))), c(S + et(d));
        } else if (a === "[object Blob]") {
          var f = new FileReader();
          f.onload = function() {
            var A = Rr + o.type + "~" + et(this.result);
            c(xe + Ze + A);
          }, f.readAsArrayBuffer(o);
        } else
          try {
            c(JSON.stringify(o));
          } catch (A) {
            console.error("Couldn't convert value into a JSON string: ", o), c(null, A);
          }
      }
      function Fr(o) {
        if (o.substring(0, qe) !== xe)
          return JSON.parse(o);
        var c = o.substring(Et), a = o.substring(qe, Et), d;
        if (a === Ze && vt.test(c)) {
          var S = c.match(vt);
          d = S[1], c = c.substring(S[0].length);
        }
        var f = Bt(c);
        switch (a) {
          case $e:
            return f;
          case Ze:
            return g([f], { type: d });
          case mt:
            return new Int8Array(f);
          case At:
            return new Uint8Array(f);
          case Pt:
            return new Uint8ClampedArray(f);
          case gt:
            return new Int16Array(f);
          case wt:
            return new Uint16Array(f);
          case Mt:
            return new Int32Array(f);
          case yt:
            return new Uint32Array(f);
          case Gt:
            return new Float32Array(f);
          case It:
            return new Float64Array(f);
          default:
            throw new Error("Unkown type: " + a);
        }
      }
      var tt = {
        serialize: Vr,
        deserialize: Fr,
        stringToBuffer: Bt,
        bufferToString: et
      };
      function Dt(o, c, a, d) {
        o.executeSql("CREATE TABLE IF NOT EXISTS " + c.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], a, d);
      }
      function xr(o) {
        var c = this, a = {
          db: null
        };
        if (o)
          for (var d in o)
            a[d] = typeof o[d] != "string" ? o[d].toString() : o[d];
        var S = new i(function(f, A) {
          try {
            a.db = openDatabase(a.name, String(a.version), a.description, a.size);
          } catch (M) {
            return A(M);
          }
          a.db.transaction(function(M) {
            Dt(M, a, function() {
              c._dbInfo = a, f();
            }, function(w, y) {
              A(y);
            });
          }, A);
        });
        return a.serializer = tt, S;
      }
      function fe(o, c, a, d, S, f) {
        o.executeSql(a, d, S, function(A, M) {
          M.code === M.SYNTAX_ERR ? A.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [c.storeName], function(w, y) {
            y.rows.length ? f(w, M) : Dt(w, c, function() {
              w.executeSql(a, d, S, f);
            }, f);
          }, f) : f(A, M);
        }, f);
      }
      function Ur(o, c) {
        var a = this;
        o = G(o);
        var d = new i(function(S, f) {
          a.ready().then(function() {
            var A = a._dbInfo;
            A.db.transaction(function(M) {
              fe(M, A, "SELECT * FROM " + A.storeName + " WHERE key = ? LIMIT 1", [o], function(w, y) {
                var E = y.rows.length ? y.rows.item(0).value : null;
                E && (E = A.serializer.deserialize(E)), S(E);
              }, function(w, y) {
                f(y);
              });
            });
          }).catch(f);
        });
        return h(d, c), d;
      }
      function kr(o, c) {
        var a = this, d = new i(function(S, f) {
          a.ready().then(function() {
            var A = a._dbInfo;
            A.db.transaction(function(M) {
              fe(M, A, "SELECT * FROM " + A.storeName, [], function(w, y) {
                for (var E = y.rows, _ = E.length, V = 0; V < _; V++) {
                  var k = E.item(V), X = k.value;
                  if (X && (X = A.serializer.deserialize(X)), X = o(X, k.key, V + 1), X !== void 0) {
                    S(X);
                    return;
                  }
                }
                S();
              }, function(w, y) {
                f(y);
              });
            });
          }).catch(f);
        });
        return h(d, c), d;
      }
      function Ht(o, c, a, d) {
        var S = this;
        o = G(o);
        var f = new i(function(A, M) {
          S.ready().then(function() {
            c === void 0 && (c = null);
            var w = c, y = S._dbInfo;
            y.serializer.serialize(c, function(E, _) {
              _ ? M(_) : y.db.transaction(function(V) {
                fe(V, y, "INSERT OR REPLACE INTO " + y.storeName + " (key, value) VALUES (?, ?)", [o, E], function() {
                  A(w);
                }, function(k, X) {
                  M(X);
                });
              }, function(V) {
                if (V.code === V.QUOTA_ERR) {
                  if (d > 0) {
                    A(Ht.apply(S, [o, w, a, d - 1]));
                    return;
                  }
                  M(V);
                }
              });
            });
          }).catch(M);
        });
        return h(f, a), f;
      }
      function Wr(o, c, a) {
        return Ht.apply(this, [o, c, a, 1]);
      }
      function Xr(o, c) {
        var a = this;
        o = G(o);
        var d = new i(function(S, f) {
          a.ready().then(function() {
            var A = a._dbInfo;
            A.db.transaction(function(M) {
              fe(M, A, "DELETE FROM " + A.storeName + " WHERE key = ?", [o], function() {
                S();
              }, function(w, y) {
                f(y);
              });
            });
          }).catch(f);
        });
        return h(d, c), d;
      }
      function Kr(o) {
        var c = this, a = new i(function(d, S) {
          c.ready().then(function() {
            var f = c._dbInfo;
            f.db.transaction(function(A) {
              fe(A, f, "DELETE FROM " + f.storeName, [], function() {
                d();
              }, function(M, w) {
                S(w);
              });
            });
          }).catch(S);
        });
        return h(a, o), a;
      }
      function jr(o) {
        var c = this, a = new i(function(d, S) {
          c.ready().then(function() {
            var f = c._dbInfo;
            f.db.transaction(function(A) {
              fe(A, f, "SELECT COUNT(key) as c FROM " + f.storeName, [], function(M, w) {
                var y = w.rows.item(0).c;
                d(y);
              }, function(M, w) {
                S(w);
              });
            });
          }).catch(S);
        });
        return h(a, o), a;
      }
      function Qr(o, c) {
        var a = this, d = new i(function(S, f) {
          a.ready().then(function() {
            var A = a._dbInfo;
            A.db.transaction(function(M) {
              fe(M, A, "SELECT key FROM " + A.storeName + " WHERE id = ? LIMIT 1", [o + 1], function(w, y) {
                var E = y.rows.length ? y.rows.item(0).key : null;
                S(E);
              }, function(w, y) {
                f(y);
              });
            });
          }).catch(f);
        });
        return h(d, c), d;
      }
      function zr(o) {
        var c = this, a = new i(function(d, S) {
          c.ready().then(function() {
            var f = c._dbInfo;
            f.db.transaction(function(A) {
              fe(A, f, "SELECT key FROM " + f.storeName, [], function(M, w) {
                for (var y = [], E = 0; E < w.rows.length; E++)
                  y.push(w.rows.item(E).key);
                d(y);
              }, function(M, w) {
                S(w);
              });
            });
          }).catch(S);
        });
        return h(a, o), a;
      }
      function Yr(o) {
        return new i(function(c, a) {
          o.transaction(function(d) {
            d.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(S, f) {
              for (var A = [], M = 0; M < f.rows.length; M++)
                A.push(f.rows.item(M).name);
              c({
                db: o,
                storeNames: A
              });
            }, function(S, f) {
              a(f);
            });
          }, function(d) {
            a(d);
          });
        });
      }
      function Jr(o, c) {
        c = D.apply(this, arguments);
        var a = this.config();
        o = typeof o != "function" && o || {}, o.name || (o.name = o.name || a.name, o.storeName = o.storeName || a.storeName);
        var d = this, S;
        return o.name ? S = new i(function(f) {
          var A;
          o.name === a.name ? A = d._dbInfo.db : A = openDatabase(o.name, "", "", 0), o.storeName ? f({
            db: A,
            storeNames: [o.storeName]
          }) : f(Yr(A));
        }).then(function(f) {
          return new i(function(A, M) {
            f.db.transaction(function(w) {
              function y(k) {
                return new i(function(X, $) {
                  w.executeSql("DROP TABLE IF EXISTS " + k, [], function() {
                    X();
                  }, function(J, ae) {
                    $(ae);
                  });
                });
              }
              for (var E = [], _ = 0, V = f.storeNames.length; _ < V; _++)
                E.push(y(f.storeNames[_]));
              i.all(E).then(function() {
                A();
              }).catch(function(k) {
                M(k);
              });
            }, function(w) {
              M(w);
            });
          });
        }) : S = i.reject("Invalid arguments"), h(S, c), S;
      }
      var qr = {
        _driver: "webSQLStorage",
        _initStorage: xr,
        _support: Nr(),
        iterate: kr,
        getItem: Ur,
        setItem: Wr,
        removeItem: Xr,
        clear: Kr,
        length: jr,
        key: Qr,
        keys: zr,
        dropInstance: Jr
      };
      function $r() {
        try {
          return typeof localStorage < "u" && "setItem" in localStorage && !!localStorage.setItem;
        } catch {
          return !1;
        }
      }
      function _t(o, c) {
        var a = o.name + "/";
        return o.storeName !== c.storeName && (a += o.storeName + "/"), a;
      }
      function Zr() {
        var o = "_localforage_support_test";
        try {
          return localStorage.setItem(o, !0), localStorage.removeItem(o), !1;
        } catch {
          return !0;
        }
      }
      function en() {
        return !Zr() || localStorage.length > 0;
      }
      function tn(o) {
        var c = this, a = {};
        if (o)
          for (var d in o)
            a[d] = o[d];
        return a.keyPrefix = _t(o, c._defaultConfig), en() ? (c._dbInfo = a, a.serializer = tt, i.resolve()) : i.reject();
      }
      function rn(o) {
        var c = this, a = c.ready().then(function() {
          for (var d = c._dbInfo.keyPrefix, S = localStorage.length - 1; S >= 0; S--) {
            var f = localStorage.key(S);
            f.indexOf(d) === 0 && localStorage.removeItem(f);
          }
        });
        return h(a, o), a;
      }
      function nn(o, c) {
        var a = this;
        o = G(o);
        var d = a.ready().then(function() {
          var S = a._dbInfo, f = localStorage.getItem(S.keyPrefix + o);
          return f && (f = S.serializer.deserialize(f)), f;
        });
        return h(d, c), d;
      }
      function on(o, c) {
        var a = this, d = a.ready().then(function() {
          for (var S = a._dbInfo, f = S.keyPrefix, A = f.length, M = localStorage.length, w = 1, y = 0; y < M; y++) {
            var E = localStorage.key(y);
            if (E.indexOf(f) === 0) {
              var _ = localStorage.getItem(E);
              if (_ && (_ = S.serializer.deserialize(_)), _ = o(_, E.substring(A), w++), _ !== void 0)
                return _;
            }
          }
        });
        return h(d, c), d;
      }
      function an(o, c) {
        var a = this, d = a.ready().then(function() {
          var S = a._dbInfo, f;
          try {
            f = localStorage.key(o);
          } catch {
            f = null;
          }
          return f && (f = f.substring(S.keyPrefix.length)), f;
        });
        return h(d, c), d;
      }
      function sn(o) {
        var c = this, a = c.ready().then(function() {
          for (var d = c._dbInfo, S = localStorage.length, f = [], A = 0; A < S; A++) {
            var M = localStorage.key(A);
            M.indexOf(d.keyPrefix) === 0 && f.push(M.substring(d.keyPrefix.length));
          }
          return f;
        });
        return h(a, o), a;
      }
      function un(o) {
        var c = this, a = c.keys().then(function(d) {
          return d.length;
        });
        return h(a, o), a;
      }
      function cn(o, c) {
        var a = this;
        o = G(o);
        var d = a.ready().then(function() {
          var S = a._dbInfo;
          localStorage.removeItem(S.keyPrefix + o);
        });
        return h(d, c), d;
      }
      function ln(o, c, a) {
        var d = this;
        o = G(o);
        var S = d.ready().then(function() {
          c === void 0 && (c = null);
          var f = c;
          return new i(function(A, M) {
            var w = d._dbInfo;
            w.serializer.serialize(c, function(y, E) {
              if (E)
                M(E);
              else
                try {
                  localStorage.setItem(w.keyPrefix + o, y), A(f);
                } catch (_) {
                  (_.name === "QuotaExceededError" || _.name === "NS_ERROR_DOM_QUOTA_REACHED") && M(_), M(_);
                }
            });
          });
        });
        return h(S, a), S;
      }
      function fn(o, c) {
        if (c = D.apply(this, arguments), o = typeof o != "function" && o || {}, !o.name) {
          var a = this.config();
          o.name = o.name || a.name, o.storeName = o.storeName || a.storeName;
        }
        var d = this, S;
        return o.name ? S = new i(function(f) {
          o.storeName ? f(_t(o, d._defaultConfig)) : f(o.name + "/");
        }).then(function(f) {
          for (var A = localStorage.length - 1; A >= 0; A--) {
            var M = localStorage.key(A);
            M.indexOf(f) === 0 && localStorage.removeItem(M);
          }
        }) : S = i.reject("Invalid arguments"), h(S, c), S;
      }
      var dn = {
        _driver: "localStorageWrapper",
        _initStorage: tn,
        _support: $r(),
        iterate: on,
        getItem: nn,
        setItem: ln,
        removeItem: cn,
        clear: rn,
        length: un,
        key: an,
        keys: sn,
        dropInstance: fn
      }, Tn = function(c, a) {
        return c === a || typeof c == "number" && typeof a == "number" && isNaN(c) && isNaN(a);
      }, Sn = function(c, a) {
        for (var d = c.length, S = 0; S < d; ) {
          if (Tn(c[S], a))
            return !0;
          S++;
        }
        return !1;
      }, Ot = Array.isArray || function(o) {
        return Object.prototype.toString.call(o) === "[object Array]";
      }, He = {}, Lt = {}, ve = {
        INDEXEDDB: Lr,
        WEBSQL: qr,
        LOCALSTORAGE: dn
      }, hn = [ve.INDEXEDDB._driver, ve.WEBSQL._driver, ve.LOCALSTORAGE._driver], Ue = ["dropInstance"], rt = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(Ue), bn = {
        description: "",
        driver: hn.slice(),
        name: "localforage",
        size: 4980736,
        storeName: "keyvaluepairs",
        version: 1
      };
      function pn(o, c) {
        o[c] = function() {
          var a = arguments;
          return o.ready().then(function() {
            return o[c].apply(o, a);
          });
        };
      }
      function nt() {
        for (var o = 1; o < arguments.length; o++) {
          var c = arguments[o];
          if (c)
            for (var a in c)
              c.hasOwnProperty(a) && (Ot(c[a]) ? arguments[0][a] = c[a].slice() : arguments[0][a] = c[a]);
        }
        return arguments[0];
      }
      var vn = function() {
        function o(c) {
          l(this, o);
          for (var a in ve)
            if (ve.hasOwnProperty(a)) {
              var d = ve[a], S = d._driver;
              this[a] = S, He[S] || this.defineDriver(d);
            }
          this._defaultConfig = nt({}, bn), this._config = nt({}, this._defaultConfig, c), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver).catch(function() {
          });
        }
        return o.prototype.config = function(a) {
          if ((typeof a > "u" ? "undefined" : s(a)) === "object") {
            if (this._ready)
              return new Error("Can't call config() after localforage has been used.");
            for (var d in a) {
              if (d === "storeName" && (a[d] = a[d].replace(/\W/g, "_")), d === "version" && typeof a[d] != "number")
                return new Error("Database version must be a number.");
              this._config[d] = a[d];
            }
            return "driver" in a && a.driver ? this.setDriver(this._config.driver) : !0;
          } else
            return typeof a == "string" ? this._config[a] : this._config;
        }, o.prototype.defineDriver = function(a, d, S) {
          var f = new i(function(A, M) {
            try {
              var w = a._driver, y = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
              if (!a._driver) {
                M(y);
                return;
              }
              for (var E = rt.concat("_initStorage"), _ = 0, V = E.length; _ < V; _++) {
                var k = E[_], X = !Sn(Ue, k);
                if ((X || a[k]) && typeof a[k] != "function") {
                  M(y);
                  return;
                }
              }
              var $ = function() {
                for (var _e = function(Pn) {
                  return function() {
                    var gn = new Error("Method " + Pn + " is not implemented by the current driver"), Nt = i.reject(gn);
                    return h(Nt, arguments[arguments.length - 1]), Nt;
                  };
                }, ot = 0, An = Ue.length; ot < An; ot++) {
                  var it = Ue[ot];
                  a[it] || (a[it] = _e(it));
                }
              };
              $();
              var J = function(_e) {
                He[w] && console.info("Redefining LocalForage driver: " + w), He[w] = a, Lt[w] = _e, A();
              };
              "_support" in a ? a._support && typeof a._support == "function" ? a._support().then(J, M) : J(!!a._support) : J(!0);
            } catch (ae) {
              M(ae);
            }
          });
          return m(f, d, S), f;
        }, o.prototype.driver = function() {
          return this._driver || null;
        }, o.prototype.getDriver = function(a, d, S) {
          var f = He[a] ? i.resolve(He[a]) : i.reject(new Error("Driver not found."));
          return m(f, d, S), f;
        }, o.prototype.getSerializer = function(a) {
          var d = i.resolve(tt);
          return m(d, a), d;
        }, o.prototype.ready = function(a) {
          var d = this, S = d._driverSet.then(function() {
            return d._ready === null && (d._ready = d._initDriver()), d._ready;
          });
          return m(S, a, a), S;
        }, o.prototype.setDriver = function(a, d, S) {
          var f = this;
          Ot(a) || (a = [a]);
          var A = this._getSupportedDrivers(a);
          function M() {
            f._config.driver = f.driver();
          }
          function w(_) {
            return f._extend(_), M(), f._ready = f._initStorage(f._config), f._ready;
          }
          function y(_) {
            return function() {
              var V = 0;
              function k() {
                for (; V < _.length; ) {
                  var X = _[V];
                  return V++, f._dbInfo = null, f._ready = null, f.getDriver(X).then(w).catch(k);
                }
                M();
                var $ = new Error("No available storage method found.");
                return f._driverSet = i.reject($), f._driverSet;
              }
              return k();
            };
          }
          var E = this._driverSet !== null ? this._driverSet.catch(function() {
            return i.resolve();
          }) : i.resolve();
          return this._driverSet = E.then(function() {
            var _ = A[0];
            return f._dbInfo = null, f._ready = null, f.getDriver(_).then(function(V) {
              f._driver = V._driver, M(), f._wrapLibraryMethodsWithReady(), f._initDriver = y(A);
            });
          }).catch(function() {
            M();
            var _ = new Error("No available storage method found.");
            return f._driverSet = i.reject(_), f._driverSet;
          }), m(this._driverSet, d, S), this._driverSet;
        }, o.prototype.supports = function(a) {
          return !!Lt[a];
        }, o.prototype._extend = function(a) {
          nt(this, a);
        }, o.prototype._getSupportedDrivers = function(a) {
          for (var d = [], S = 0, f = a.length; S < f; S++) {
            var A = a[S];
            this.supports(A) && d.push(A);
          }
          return d;
        }, o.prototype._wrapLibraryMethodsWithReady = function() {
          for (var a = 0, d = rt.length; a < d; a++)
            pn(this, rt[a]);
        }, o.prototype.createInstance = function(a) {
          return new o(a);
        }, o;
      }(), mn = new vn();
      r.exports = mn;
    }, { 3: 3 }] }, {}, [4])(4);
  });
})(vr);
var st = vr.exports;
const io = typeof atob == "function", ao = typeof btoa == "function", Ce = typeof Buffer == "function", Yt = typeof TextDecoder == "function" ? new TextDecoder() : void 0, Jt = typeof TextEncoder == "function" ? new TextEncoder() : void 0, so = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Oe = Array.prototype.slice.call(so), je = ((e) => {
  let t = {};
  return e.forEach((n, r) => t[n] = r), t;
})(Oe), uo = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, ee = String.fromCharCode.bind(String), qt = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (e) => new Uint8Array(Array.prototype.slice.call(e, 0)), co = (e) => e.replace(/=/g, "").replace(/[+\/]/g, (t) => t == "+" ? "-" : "_"), mr = (e) => e.replace(/[^A-Za-z0-9\+\/]/g, ""), lo = (e) => {
  let t, n, r, u, s = "";
  const l = e.length % 3;
  for (let T = 0; T < e.length; ) {
    if ((n = e.charCodeAt(T++)) > 255 || (r = e.charCodeAt(T++)) > 255 || (u = e.charCodeAt(T++)) > 255)
      throw new TypeError("invalid character found");
    t = n << 16 | r << 8 | u, s += Oe[t >> 18 & 63] + Oe[t >> 12 & 63] + Oe[t >> 6 & 63] + Oe[t & 63];
  }
  return l ? s.slice(0, l - 3) + "===".substring(l) : s;
}, Ar = ao ? (e) => btoa(e) : Ce ? (e) => Buffer.from(e, "binary").toString("base64") : lo, fo = Ce ? (e) => Buffer.from(e).toString("base64") : (e) => {
  let n = [];
  for (let r = 0, u = e.length; r < u; r += 4096)
    n.push(ee.apply(null, e.subarray(r, r + 4096)));
  return Ar(n.join(""));
}, To = (e) => {
  if (e.length < 2) {
    var t = e.charCodeAt(0);
    return t < 128 ? e : t < 2048 ? ee(192 | t >>> 6) + ee(128 | t & 63) : ee(224 | t >>> 12 & 15) + ee(128 | t >>> 6 & 63) + ee(128 | t & 63);
  } else {
    var t = 65536 + (e.charCodeAt(0) - 55296) * 1024 + (e.charCodeAt(1) - 56320);
    return ee(240 | t >>> 18 & 7) + ee(128 | t >>> 12 & 63) + ee(128 | t >>> 6 & 63) + ee(128 | t & 63);
  }
}, So = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, ho = (e) => e.replace(So, To), $t = Ce ? (e) => Buffer.from(e, "utf8").toString("base64") : Jt ? (e) => fo(Jt.encode(e)) : (e) => Ar(ho(e)), bo = (e, t = !1) => t ? co($t(e)) : $t(e), po = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, vo = (e) => {
  switch (e.length) {
    case 4:
      var t = (7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3), n = t - 65536;
      return ee((n >>> 10) + 55296) + ee((n & 1023) + 56320);
    case 3:
      return ee((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));
    default:
      return ee((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
  }
}, mo = (e) => e.replace(po, vo), Ao = (e) => {
  if (e = e.replace(/\s+/g, ""), !uo.test(e))
    throw new TypeError("malformed base64.");
  e += "==".slice(2 - (e.length & 3));
  let t, n = "", r, u;
  for (let s = 0; s < e.length; )
    t = je[e.charAt(s++)] << 18 | je[e.charAt(s++)] << 12 | (r = je[e.charAt(s++)]) << 6 | (u = je[e.charAt(s++)]), n += r === 64 ? ee(t >> 16 & 255) : u === 64 ? ee(t >> 16 & 255, t >> 8 & 255) : ee(t >> 16 & 255, t >> 8 & 255, t & 255);
  return n;
}, Pr = io ? (e) => atob(mr(e)) : Ce ? (e) => Buffer.from(e, "base64").toString("binary") : Ao, Po = Ce ? (e) => qt(Buffer.from(e, "base64")) : (e) => qt(Pr(e).split("").map((t) => t.charCodeAt(0))), go = Ce ? (e) => Buffer.from(e, "base64").toString("utf8") : Yt ? (e) => Yt.decode(Po(e)) : (e) => mo(Pr(e)), Mo = (e) => mr(e.replace(/[-_]/g, (t) => t == "-" ? "+" : "/")), wo = (e) => go(Mo(e));
function yo(e, t) {
  t && e.then(function(n) {
    t(null, n);
  }, function(n) {
    t(n, null);
  });
}
function Go(e) {
  var t = st.createInstance({
    name: e,
    driver: [st.INDEXEDDB, st.LOCALSTORAGE]
  });
  function n() {
    for (var u = [], s = 0; s < arguments.length; s++)
      u[s] = arguments[s];
    var l = u[0], T = u[1], p = u.length - 2, v = u.length - 1, g = typeof u[p] == "function" ? u[p] : void 0, i = typeof u[v] == "object" ? u[v] : void 0, h = {
      __bak_value: T
    };
    if (i && Object.prototype.toString.call(i) === "[object Object]") {
      var m = i.expire, G = i.encryption;
      G && (h.__bak_value = bo(JSON.stringify(T)), h.__is_encryption = !0), m && typeof m == "number" && (h = Q(Q({}, h), { __expire_timestamp: Date.now() + m * 1e3 }));
    }
    return t.setItem(l, h, g);
  }
  function r(u, s) {
    var l = this, T = new Promise(function(p, v) {
      t.getItem(u).then(function(g) {
        return te(l, void 0, void 0, function() {
          var i, h, m, G, D;
          return re(this, function(O) {
            switch (O.label) {
              case 0:
                return g === null && p(null), i = g, h = i.__bak_value, m = i.__is_encryption, G = i.__expire_timestamp, D = h, m && (D = JSON.parse(wo(h))), Date.now() > G ? [4, t.removeItem(u)] : [3, 2];
              case 1:
                O.sent(), D = null, O.label = 2;
              case 2:
                return p(D), [2];
            }
          });
        });
      }).catch(function(g) {
        v(g);
      });
    });
    return yo(T, s), T;
  }
  return {
    setItem: n,
    getItem: r,
    removeItem: t.removeItem,
    clear: t.clear
  };
}
function gr(e) {
  return Go(e);
}
var Io = gr("_DEFAULT_"), Zt = ["crm", "platform", "growth", "mall", "cs"].reduce(function(e, t) {
  return e[t] = gr(t), e;
}, Io);
function Mr(e) {
  return te(this, void 0, void 0, function() {
    var t, n, r, u;
    return re(this, function(s) {
      switch (s.label) {
        case 0:
          return s.trys.push([0, 2, , 3]), [4, e];
        case 1:
          return t = s.sent(), n = t.success, r = t.data, n ? [2, r] : [3, 3];
        case 2:
          return u = s.sent(), console.error(u), [3, 3];
        case 3:
          throw new Error("fetch error");
      }
    });
  });
}
function Eo() {
  var e = pe();
  function t() {
    return te(this, void 0, void 0, function() {
      var r, u, s, l, T, p, v, g, i, h;
      return re(this, function(m) {
        switch (m.label) {
          case 0:
            return m.trys.push([0, 2, , 3]), [4, Mr(ti({ type: "pc" }))];
          case 1:
            return r = m.sent(), u = r.func, s = u === void 0 ? [] : u, l = r.pcMenu, T = l === void 0 ? [] : l, p = r.data, v = p === void 0 ? {} : p, g = r.menu, i = new Set(Ge(Ge([], s, !0), T, !0)), e.emitData(ce.Access, {
              funcSet: i,
              data: v,
              menu: g
            }, !1), [2, !0];
          case 2:
            return h = m.sent(), console.error(h), [3, 3];
          case 3:
            return [2, !1];
        }
      });
    });
  }
  function n() {
    return e.getData(ce.Access, !1);
  }
  return {
    loadAccess: t,
    data: n
  };
}
function Co(e) {
  return typeof e == "object" || Object.prototype.toString.call(e) === "[object Object]";
}
var Bo = function() {
  function e(t) {
    t === void 0 && (t = {}), Object.defineProperty(this, "env", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {}
    });
    var n = process.env || {}, r = {}, u = {};
    typeof window < "u" && (r = window[t.key || "envConfig"] || {}), n.NODE_ENV === "development" && Co(t.developmentEnvs) && (u = Q({}, t.developmentEnvs)), this.env = Object.freeze(Q(Q(Q({}, n), r), u));
  }
  return Object.defineProperty(e.prototype, "get", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      var n = Object.hasOwnProperty.call(this.env, t);
      if (!n)
        throw new Error("当前的环境变量集合中不存在【".concat(t, "】，请检查变量名称是否正确"));
      return this.env[t];
    }
  }), Object.defineProperty(e.prototype, "getBaseUrl", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      return t === void 0 && (t = "pc"), t === "pc" ? this.get("VUE_APP_PC_B_BASE_URL") : this.get("VUE_APP_QW_SCRM_BASE_URL");
    }
  }), Object.defineProperty(e.prototype, "getSocketUrl", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      return this.get("VUE_APP_WEBSOCKET_BASE_URL") + "/sub";
    }
  }), e;
}(), wr = new Bo();
function Je() {
  return Je = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Je.apply(this, arguments);
}
function Do(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
var Ho = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = {});
    var r = process.env, u = {}, s = {};
    typeof window < "u" && (u = window[n.key || "envConfig"] || {}), r.NODE_ENV === "development" && Do(n.devInjectEnvs) && (s = Je({}, n.devInjectEnvs)), this.env = Object.freeze(Je({}, r, u, s));
  }
  var t = e.prototype;
  return t.get = function(r) {
    var u = Object.hasOwnProperty.call(this.env, r);
    if (!u)
      throw new Error("当前的环境变量集合中不存在[" + r + "]，请检查变量名称是否正确");
    return this.env[r];
  }, e;
}();
function Ne() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  Ne = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, r = typeof Symbol == "function" ? Symbol : {}, u = r.iterator || "@@iterator", s = r.asyncIterator || "@@asyncIterator", l = r.toStringTag || "@@toStringTag";
  function T(P, b, I) {
    return Object.defineProperty(P, b, {
      value: I,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), P[b];
  }
  try {
    T({}, "");
  } catch {
    T = function(b, I, H) {
      return b[I] = H;
    };
  }
  function p(P, b, I, H) {
    var C = b && b.prototype instanceof i ? b : i, F = Object.create(C.prototype), j = new L(H || []);
    return F._invoke = /* @__PURE__ */ function(z, ie, W) {
      var ne = "suspendedStart";
      return function(q, Be) {
        if (ne === "executing")
          throw new Error("Generator is already running");
        if (ne === "completed") {
          if (q === "throw")
            throw Be;
          return K();
        }
        for (W.method = q, W.arg = Be; ; ) {
          var Fe = W.delegate;
          if (Fe) {
            var De = Y(Fe, W);
            if (De) {
              if (De === g)
                continue;
              return De;
            }
          }
          if (W.method === "next")
            W.sent = W._sent = W.arg;
          else if (W.method === "throw") {
            if (ne === "suspendedStart")
              throw ne = "completed", W.arg;
            W.dispatchException(W.arg);
          } else
            W.method === "return" && W.abrupt("return", W.arg);
          ne = "executing";
          var Te = v(z, ie, W);
          if (Te.type === "normal") {
            if (ne = W.done ? "completed" : "suspendedYield", Te.arg === g)
              continue;
            return {
              value: Te.arg,
              done: W.done
            };
          }
          Te.type === "throw" && (ne = "completed", W.method = "throw", W.arg = Te.arg);
        }
      };
    }(P, I, j), F;
  }
  function v(P, b, I) {
    try {
      return {
        type: "normal",
        arg: P.call(b, I)
      };
    } catch (H) {
      return {
        type: "throw",
        arg: H
      };
    }
  }
  e.wrap = p;
  var g = {};
  function i() {
  }
  function h() {
  }
  function m() {
  }
  var G = {};
  T(G, u, function() {
    return this;
  });
  var D = Object.getPrototypeOf, O = D && D(D(x([])));
  O && O !== t && n.call(O, u) && (G = O);
  var U = m.prototype = i.prototype = Object.create(G);
  function N(P) {
    ["next", "throw", "return"].forEach(function(b) {
      T(P, b, function(I) {
        return this._invoke(b, I);
      });
    });
  }
  function Z(P, b) {
    function I(C, F, j, z) {
      var ie = v(P[C], P, F);
      if (ie.type !== "throw") {
        var W = ie.arg, ne = W.value;
        return ne && typeof ne == "object" && n.call(ne, "__await") ? b.resolve(ne.__await).then(function(q) {
          I("next", q, j, z);
        }, function(q) {
          I("throw", q, j, z);
        }) : b.resolve(ne).then(function(q) {
          W.value = q, j(W);
        }, function(q) {
          return I("throw", q, j, z);
        });
      }
      z(ie.arg);
    }
    var H;
    this._invoke = function(C, F) {
      function j() {
        return new b(function(z, ie) {
          I(C, F, z, ie);
        });
      }
      return H = H ? H.then(j, j) : j();
    };
  }
  function Y(P, b) {
    var I = P.iterator[b.method];
    if (I === void 0) {
      if (b.delegate = null, b.method === "throw") {
        if (P.iterator.return && (b.method = "return", b.arg = void 0, Y(P, b), b.method === "throw"))
          return g;
        b.method = "throw", b.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return g;
    }
    var H = v(I, P.iterator, b.arg);
    if (H.type === "throw")
      return b.method = "throw", b.arg = H.arg, b.delegate = null, g;
    var C = H.arg;
    return C ? C.done ? (b[P.resultName] = C.value, b.next = P.nextLoc, b.method !== "return" && (b.method = "next", b.arg = void 0), b.delegate = null, g) : C : (b.method = "throw", b.arg = new TypeError("iterator result is not an object"), b.delegate = null, g);
  }
  function B(P) {
    var b = {
      tryLoc: P[0]
    };
    1 in P && (b.catchLoc = P[1]), 2 in P && (b.finallyLoc = P[2], b.afterLoc = P[3]), this.tryEntries.push(b);
  }
  function R(P) {
    var b = P.completion || {};
    b.type = "normal", delete b.arg, P.completion = b;
  }
  function L(P) {
    this.tryEntries = [{
      tryLoc: "root"
    }], P.forEach(B, this), this.reset(!0);
  }
  function x(P) {
    if (P) {
      var b = P[u];
      if (b)
        return b.call(P);
      if (typeof P.next == "function")
        return P;
      if (!isNaN(P.length)) {
        var I = -1, H = function C() {
          for (; ++I < P.length; )
            if (n.call(P, I))
              return C.value = P[I], C.done = !1, C;
          return C.value = void 0, C.done = !0, C;
        };
        return H.next = H;
      }
    }
    return {
      next: K
    };
  }
  function K() {
    return {
      value: void 0,
      done: !0
    };
  }
  return h.prototype = m, T(U, "constructor", m), T(m, "constructor", h), h.displayName = T(m, l, "GeneratorFunction"), e.isGeneratorFunction = function(P) {
    var b = typeof P == "function" && P.constructor;
    return !!b && (b === h || (b.displayName || b.name) === "GeneratorFunction");
  }, e.mark = function(P) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(P, m) : (P.__proto__ = m, T(P, l, "GeneratorFunction")), P.prototype = Object.create(U), P;
  }, e.awrap = function(P) {
    return {
      __await: P
    };
  }, N(Z.prototype), T(Z.prototype, s, function() {
    return this;
  }), e.AsyncIterator = Z, e.async = function(P, b, I, H, C) {
    C === void 0 && (C = Promise);
    var F = new Z(p(P, b, I, H), C);
    return e.isGeneratorFunction(b) ? F : F.next().then(function(j) {
      return j.done ? j.value : F.next();
    });
  }, N(U), T(U, l, "Generator"), T(U, u, function() {
    return this;
  }), T(U, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(P) {
    var b = [];
    for (var I in P)
      b.push(I);
    return b.reverse(), function H() {
      for (; b.length; ) {
        var C = b.pop();
        if (C in P)
          return H.value = C, H.done = !1, H;
      }
      return H.done = !0, H;
    };
  }, e.values = x, L.prototype = {
    constructor: L,
    reset: function(P) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(R), !P)
        for (var b in this)
          b.charAt(0) === "t" && n.call(this, b) && !isNaN(+b.slice(1)) && (this[b] = void 0);
    },
    stop: function() {
      this.done = !0;
      var P = this.tryEntries[0].completion;
      if (P.type === "throw")
        throw P.arg;
      return this.rval;
    },
    dispatchException: function(P) {
      if (this.done)
        throw P;
      var b = this;
      function I(ie, W) {
        return F.type = "throw", F.arg = P, b.next = ie, W && (b.method = "next", b.arg = void 0), !!W;
      }
      for (var H = this.tryEntries.length - 1; H >= 0; --H) {
        var C = this.tryEntries[H], F = C.completion;
        if (C.tryLoc === "root")
          return I("end");
        if (C.tryLoc <= this.prev) {
          var j = n.call(C, "catchLoc"), z = n.call(C, "finallyLoc");
          if (j && z) {
            if (this.prev < C.catchLoc)
              return I(C.catchLoc, !0);
            if (this.prev < C.finallyLoc)
              return I(C.finallyLoc);
          } else if (j) {
            if (this.prev < C.catchLoc)
              return I(C.catchLoc, !0);
          } else {
            if (!z)
              throw new Error("try statement without catch or finally");
            if (this.prev < C.finallyLoc)
              return I(C.finallyLoc);
          }
        }
      }
    },
    abrupt: function(P, b) {
      for (var I = this.tryEntries.length - 1; I >= 0; --I) {
        var H = this.tryEntries[I];
        if (H.tryLoc <= this.prev && n.call(H, "finallyLoc") && this.prev < H.finallyLoc) {
          var C = H;
          break;
        }
      }
      C && (P === "break" || P === "continue") && C.tryLoc <= b && b <= C.finallyLoc && (C = null);
      var F = C ? C.completion : {};
      return F.type = P, F.arg = b, C ? (this.method = "next", this.next = C.finallyLoc, g) : this.complete(F);
    },
    complete: function(P, b) {
      if (P.type === "throw")
        throw P.arg;
      return P.type === "break" || P.type === "continue" ? this.next = P.arg : P.type === "return" ? (this.rval = this.arg = P.arg, this.method = "return", this.next = "end") : P.type === "normal" && b && (this.next = b), g;
    },
    finish: function(P) {
      for (var b = this.tryEntries.length - 1; b >= 0; --b) {
        var I = this.tryEntries[b];
        if (I.finallyLoc === P)
          return this.complete(I.completion, I.afterLoc), R(I), g;
      }
    },
    catch: function(P) {
      for (var b = this.tryEntries.length - 1; b >= 0; --b) {
        var I = this.tryEntries[b];
        if (I.tryLoc === P) {
          var H = I.completion;
          if (H.type === "throw") {
            var C = H.arg;
            R(I);
          }
          return C;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(P, b, I) {
      return this.delegate = {
        iterator: x(P),
        resultName: b,
        nextLoc: I
      }, this.method === "next" && (this.arg = void 0), g;
    }
  }, e;
}
function er(e, t, n, r, u, s, l) {
  try {
    var T = e[s](l), p = T.value;
  } catch (v) {
    n(v);
    return;
  }
  T.done ? t(p) : Promise.resolve(p).then(r, u);
}
function yr(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, u) {
      var s = e.apply(t, n);
      function l(p) {
        er(s, r, u, l, T, "next", p);
      }
      function T(p) {
        er(s, r, u, l, T, "throw", p);
      }
      l(void 0);
    });
  };
}
function _o(e) {
  return St.apply(this, arguments);
}
function St() {
  return St = yr(/* @__PURE__ */ Ne().mark(function e(t) {
    var n, r, u;
    return Ne().wrap(function(l) {
      for (; ; )
        switch (l.prev = l.next) {
          case 0:
            return n = t.url, l.next = 3, fetch(n, {
              method: "get"
            });
          case 3:
            return r = l.sent, l.next = 6, r.json();
          case 6:
            if (l.t0 = l.sent, l.t0) {
              l.next = 9;
              break;
            }
            l.t0 = {};
          case 9:
            return u = l.t0, l.abrupt("return", u);
          case 11:
          case "end":
            return l.stop();
        }
    }, e);
  })), St.apply(this, arguments);
}
function Oo(e) {
  var t = e.prefix, n = e.key, r = e.field, u = e.fileType, s = e.teamName, l = e.timestamp, T = e.envName, p = n + "." + u;
  T === "dev" && (T = "dev1"), T === "master" && (T = "master1"), T === "release" && (T = "ali");
  var v = "/cfx-config-platform/" + r + "/" + (s ? "teamName/" : "") + T + "/" + p;
  return l && (v += "?time=" + Date.now()), "" + t + v;
}
function Lo(e, t, n) {
  return ht.apply(this, arguments);
}
function ht() {
  return ht = yr(/* @__PURE__ */ Ne().mark(function e(t, n, r) {
    var u, s, l, T, p, v, g;
    return Ne().wrap(function(h) {
      for (; ; )
        switch (h.prev = h.next) {
          case 0:
            return n === void 0 && (n = !0), r === void 0 && (r = "window"), u = r === "window" ? new Ho().env : process.env, s = u.VUE_APP_ICONFIG_CDN_PREFIX, l = u.VUE_APP_ICONFIG_FIELD_NAME, T = u.VUE_APP_ICONFIG_ENV, p = u.VUE_APP_MKCONFIG_ENV, v = Oo({
              key: t,
              prefix: s,
              field: l || "scrm",
              envName: T || p,
              fileType: "json",
              timestamp: n
            }), h.next = 7, _o({
              url: v
            });
          case 7:
            return g = h.sent, h.abrupt("return", g);
          case 9:
          case "end":
            return h.stop();
        }
    }, e);
  })), ht.apply(this, arguments);
}
var No = {}, Gr = [];
function tr(e) {
  pe().emitData(ce.OEM, e, !1), Gr.forEach(function(t) {
    typeof t == "function" && t(e);
  });
}
function ut() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = No;
  return Object.assign.apply(Object, Ge([n], e, !1)), n;
}
function Ro(e) {
  return e === null ? !0 : typeof e == "object" ? !Object.keys(e).length : !1;
}
function Vo() {
  return te(this, void 0, void 0, function() {
    var e, t, n, r;
    return re(this, function(u) {
      switch (u.label) {
        case 0:
          return e = new URLSearchParams(location.href.split("?")[1]).get("corpId") || br().corpId || "", e ? [4, Ve.network.get("account/v1/enterprise_info", { corpId: e })] : [2, {}];
        case 1:
          return t = u.sent(), n = t.success, r = t.data, [2, n ? r : {}];
      }
    });
  });
}
function Fo() {
  return te(this, void 0, void 0, function() {
    var e, t, n;
    return re(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Ve.network.get("/biz/v1/qw_account/anonymous/oem/agent", {
            domain: window.location.host
          }, {
            baseURL: wr.get("VUE_APP_QW_SCRM_BASE_URL")
          })];
        case 1:
          return e = r.sent(), t = e.success, n = e.data, [2, t ? n : null];
      }
    });
  });
}
function rr() {
  return te(this, void 0, void 0, function() {
    var e, t;
    return re(this, function(n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 2, , 3]), [4, Lo("oemConfig")];
        case 1:
          return e = n.sent(), [2, e || {}];
        case 2:
          return t = n.sent(), console.log(t, "获取oem配置文件错误"), [2, {}];
        case 3:
          return [2];
      }
    });
  });
}
function xo() {
  var e = this, t = function(s) {
    var l = ut(s);
    return tr(l), l;
  }, n = function() {
    return te(e, void 0, void 0, function() {
      var s, l, T, p, p;
      return re(this, function(v) {
        switch (v.label) {
          case 0:
            return [4, Fo()];
          case 1:
            return s = v.sent(), [4, Vo()];
          case 2:
            return l = v.sent(), T = {}, s && !Ro(s) ? s.icon ? [3, 4] : [4, rr()] : [3, 5];
          case 3:
            p = v.sent(), s.icon = p.icon || p.defaultIcon, v.label = 4;
          case 4:
            return T = ut(s, l), [3, 7];
          case 5:
            return [4, rr()];
          case 6:
            p = v.sent(), T = ut(p, l), v.label = 7;
          case 7:
            return tr(T), [2, T];
        }
      });
    });
  }, r = function(s) {
    Gr.push(s);
  };
  function u() {
    return pe().getData(ce.OEM, !1) || {};
  }
  return {
    fetchOEM: n,
    setOEM: t,
    onUpdate: r,
    getOEM: u
  };
}
function Uo() {
  var e = pe();
  function t() {
    return te(this, void 0, void 0, function() {
      var r, u;
      return re(this, function(s) {
        switch (s.label) {
          case 0:
            return s.trys.push([0, 2, , 3]), [4, Mr(ri())];
          case 1:
            return r = s.sent(), r.is_phone_repeat = r.repeat_mode === 0, e.emitData(ce.SwitchConfig, r, !1), [2, !0];
          case 2:
            return u = s.sent(), console.error(u), [3, 3];
          case 3:
            return [2, !1];
        }
      });
    });
  }
  function n() {
    return e.getData(ce.SwitchConfig, !1);
  }
  return {
    loadSwitchConfig: t,
    data: n
  };
}
var nr;
(function(e) {
  e.Self = "Self", e.Third = "Third", e.Provided = "Provided", e.ProvidedUpgraded = "ProvidedUpgraded";
})(nr || (nr = {}));
function ko() {
  var e = Eo(), t = Uo();
  function n() {
    return te(this, void 0, void 0, function() {
      var r;
      return re(this, function(u) {
        switch (u.label) {
          case 0:
            return [4, Promise.all([
              e.loadAccess(),
              t.loadSwitchConfig()
            ])];
          case 1:
            return r = u.sent(), [2, !r.some(function(s) {
              return !s;
            })];
        }
      });
    });
  }
  return {
    loadData: n,
    accessData: e.data,
    switchData: t.data
  };
}
var Wo = [
  {
    id: "if-1111",
    type: "iframe",
    config: {
      url: "http://www.baidu.com"
    }
  }
], Xo = [
  {
    id: "mf-001",
    type: "mf",
    config: {
      name: "",
      scope: "",
      publicPath: "/"
    }
  }
], Ko = [
  {
    id: "app-12132",
    type: "micro",
    config: {
      name: "",
      path: ""
    }
  }
];
function or(e, t) {
  var n = /* @__PURE__ */ new Map();
  return e && (e.forEach(function(r) {
    if (r.id) {
      var u = t == null ? void 0 : t.get(r.id);
      if (u) {
        t == null || t.delete(r.id), n.set(r.id, Q(Q({}, r), u));
        return;
      }
      n.set(r.id, r);
    }
  }), t != null && t.size && t.forEach(function(r, u) {
    n.set(u, r);
  })), n;
}
function jo(e) {
  var t = or(e), n = Ge(Ge(Ge([], Xo, !0), Wo, !0), Ko, !0), r = or(n, t);
  return r;
}
var me = function(e) {
  return function(t) {
    return t.hash.startsWith(e);
  };
}, Qo = [
  {
    name: "scrm-manage-workbench",
    publicPath: "workbench",
    port: 5001,
    activeRule: me("#/workbench")
  },
  {
    name: "qw-manage-work-order-client",
    publicPath: "workorder",
    port: 3001,
    activeRule: me("#/workbench")
  },
  {
    name: "qw-manage-crm-report-client",
    publicPath: "crm-report",
    port: 3001,
    activeRule: me("#/workbench")
  },
  {
    name: "scrm-manage-customer",
    publicPath: "scrm-manage-customer",
    port: 4003,
    activeRule: me("#/customer")
  },
  {
    name: "scrm-manage-salechance",
    publicPath: "scrm-manage-salechance",
    port: 4002,
    activeRule: me("#/customer")
  },
  {
    name: "scrm-manage-opensea",
    publicPath: "scrm-manage-opensea",
    port: 4100,
    activeRule: me("#/customer")
  }
];
function zo(e) {
  var t = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    t.set(n.name, n);
  }), t;
}
function Yo() {
  var e = zo(Qo);
  function t(r) {
    r.length && r.forEach(function(u) {
      var s = e.get(u.name) || {};
      e.set(u.name, Object.assign({}, s, u));
    });
  }
  function n(r, u) {
    u === void 0 && (u = {});
    var s = e.get(r);
    return s ? Q(Q({}, s), u) : u;
  }
  return {
    registerApps: t,
    getApp: n
  };
}
Yo();
function Jo(e) {
  var t = { value: e };
  return {
    value: function() {
      return t.value;
    },
    setValue: function(n) {
      t.value = n;
    }
  };
}
function qo() {
  var e = pe(), t = Jo(), n = Ie(), r;
  function u(p) {
    e.emitData(ce.Components, jo(p), !1);
  }
  function s(p) {
    var v = e.getData(ce.Components, !1);
    return v == null ? void 0 : v.get(p);
  }
  function l(p) {
    return te(this, void 0, void 0, function() {
      var v, g;
      return re(this, function(i) {
        return v = t.value(), v ? (g = s(p.id), g ? [2, v(Q(Q({}, g), p))] : (n.dispatch(de.PresentEventApp, p), [2, !1])) : (console.error("Not register components presenter"), [2, !1]);
      });
    });
  }
  function T(p) {
    var v = this, g = function(i) {
      var h = i.detail;
      return te(v, void 0, void 0, function() {
        return re(this, function(m) {
          switch (m.label) {
            case 0:
              return [4, l(h)];
            case 1:
              return m.sent(), [2];
          }
        });
      });
    };
    return r && r(), t.setValue(p), n.on(de.PresentEvent, g), r = function() {
      n.off(de.PresentEvent, g), t.setValue(void 0);
    }, r;
  }
  return {
    registerGlobalComponents: u,
    registerPresenter: T
  };
}
qo();
var Ae, Qe = {
  CreateCustomer: "draft.type.customer.form",
  CreateWorkOrder: "draft.type.workorder.form",
  CreateOrder: "draft.type.order.form",
  DraftTest: "draft.type.for.test"
};
Ae = {}, Ae[Qe.CreateCustomer] = "新建联系人", Ae[Qe.CreateWorkOrder] = "新建工单", Ae[Qe.CreateOrder] = "新建订单", Ae[Qe.DraftTest] = "草稿箱测试";
var Le, we, ye, ze;
function $o() {
  var e = pe();
  function t(r) {
    e.emitData(ce.InitSdk, r, !1);
  }
  function n() {
    return !!e.getData(ce.InitSdk, !1);
  }
  return {
    setState: t,
    getState: n
  };
}
var Zo = function() {
  function e() {
    Object.defineProperty(this, "network", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {}
    }), Object.defineProperty(this, "dataManager", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: ko()
    }), Object.defineProperty(this, "websocket", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Le.set(this, {}), we.set(this, !1), ye.set(this, "pc"), ze.set(this, !1), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "idle"
    }), Object.defineProperty(this, "globalState", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: $o()
    });
  }
  return Object.defineProperty(e.prototype, "initOem", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      return te(this, void 0, void 0, function() {
        var t;
        return re(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, xo().fetchOEM()];
            case 1:
              return t = n.sent(), [2, !!Object.keys(t).length];
          }
        });
      });
    }
  }), Object.defineProperty(e.prototype, "initSdk", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      var n = t.useNetwork, r = t.useWebSocket, u = t.accessMethodMap, s = t.sessionLoginOptions, l = s === void 0 ? {} : s, T = t.noAuth, p = T === void 0 ? !1 : T, v = t.platform, g = v === void 0 ? "pc" : v, i = t.noFetchBaseData, h = i === void 0 ? !1 : i;
      return te(this, void 0, void 0, function() {
        var m, G;
        return re(this, function(D) {
          switch (D.label) {
            case 0:
              return this.network = n, Pe(this, ye, g === "pc" ? "pc" : "qw"), Pe(this, we, p), Pe(this, ze, h), u && Pe(this, Le, u), this.globalState.getState() ? !p && !Ye(g) ? [2, !1] : (this.status = "init", this.notifySuccess(), [2, !0]) : [3, 1];
            case 1:
              return p ? [3, 3] : (l = Q(Q({}, l), { type: oe(this, ye, "f") }), [4, di(l)]);
            case 2:
              if (m = D.sent(), !m)
                return console.error("user auth error"), this.status = "fail", [2, !1];
              D.label = 3;
            case 3:
              return r && (this.websocket = Si(r)), [4, this.reloadData()];
            case 4:
              return G = D.sent(), [2, G];
          }
        });
      });
    }
  }), Object.defineProperty(e.prototype, "notifySuccess", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      Wn.dispatch(de.InitCoreSdk, { success: !0 }), this.globalState.setState(!0);
    }
  }), Object.defineProperty(e.prototype, "reloadData", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      return te(this, void 0, void 0, function() {
        var t, n, r;
        return re(this, function(u) {
          switch (u.label) {
            case 0:
              if (!this.network)
                return [2, !1];
              if (oe(this, ze, "f"))
                return this.notifySuccess(), [2, !0];
              if (t = [], oe(this, ye, "f") === "pc" && (t = oe(this, we, "f") ? [this.initOem()] : [this.initOem(), this.loadGlobalData()]), oe(this, ye, "f") === "qw") {
                if (oe(this, we, "f"))
                  return this.notifySuccess(), [2, !0];
                t = oe(this, we, "f") ? [] : [this.loadGlobalData()];
              }
              return [4, Promise.all(t)];
            case 1:
              return n = u.sent(), r = !n.some(function(s) {
                return !s;
              }), this.status = r ? "init" : "fail", r && this.notifySuccess(), [2, r];
          }
        });
      });
    }
  }), Object.defineProperty(e.prototype, "isInit", {
    get: function() {
      return this.status === "init";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "getStatus", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      return this.status;
    }
  }), Object.defineProperty(e.prototype, "loadGlobalData", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      return te(this, void 0, void 0, function() {
        return re(this, function(t) {
          return [2, this.dataManager.loadData()];
        });
      });
    }
  }), Object.defineProperty(e.prototype, "getAccessMethod", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      return oe(this, Le, "f")[t];
    }
  }), Object.defineProperty(e.prototype, "destroy", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      var t;
      Pe(this, Le, {}), kn.destroy(), (t = this.websocket) === null || t === void 0 || t.destroy();
    }
  }), e;
}();
Le = /* @__PURE__ */ new WeakMap(), we = /* @__PURE__ */ new WeakMap(), ye = /* @__PURE__ */ new WeakMap(), ze = /* @__PURE__ */ new WeakMap();
var Ve = new Zo();
function ei(e) {
  return Ve.network.get("/biz/v1/qw_account/session/get_login_session", e);
}
function ti(e) {
  return Ve.network.get("/biz/v1/qw_account/menu/sort/list", e);
}
function ri() {
  return Ve.network.get("/qw-scrm-svc/action/common/switchConfig", {});
}
var ni = ["/login", "/no-auth"], oi = function(e) {
  return e === "pc" ? location.pathname.includes("scrm-manage") ? "/scrm-manage/no-auth" : "/qw-manage/#/no-auth" : "/common-login/#/no-login-power";
}, ii = function(e) {
  return e === "pc" ? location.pathname.includes("scrm-manage") ? "/scrm-manage/no-auth" : "/qw-manage/#/no-auth" : "/common-login/#/error";
};
function ai(e) {
  var t = location.href;
  return (e || []).some(function(n) {
    return t.includes(n);
  });
}
function ct(e, t) {
  if (e) {
    var n = typeof e == "function" ? e() : e;
    Tr.replace({
      path: n,
      query: t
    });
  }
}
function si(e) {
  e === void 0 && (e = "pc");
  var t = 1, n = br(e);
  if (!n) {
    if (zn())
      return !1;
    var r = /[A-Za-z0-9-]+-qw-scrm/, u = window.location.origin;
    return !r.test(u);
  }
  return n.account_type ? n.account_type === t : !1;
}
var ui = function() {
  return location.pathname.includes("scrm-manage") ? "/scrm-manage/login" : "/qw-manage/#/login";
};
function ci(e) {
  var t = typeof e == "function" ? e() : ui(), n = pr("pc") || {}, r = n.agentId, u = n.corpId, s = {
    path: t
  };
  r && u && (s.query = {
    corpId: u,
    agentId: r
  }), si() && (s.query = Q(Q({}, s.query), { third: "true" })), Tr.replace(s);
}
var li = function(e) {
  var t = window.location, n = t.origin, r = t.pathname, u = t.hash, s = u.split("?"), l = s[0], T = s[1], p = "corpId=".concat(e.corpId || e.corpid, "&agentId=").concat(e.agentId, "&autoLogin=true");
  if (T) {
    var v = [
      "isSideMenu",
      "corpId",
      "agentId",
      "autoLogin",
      "sessionId"
    ], g = {};
    T.split("&").forEach(function(h) {
      var m = h.split("="), G = m[0], D = m[1];
      D && !v.includes(G) && (g[G] = D);
    });
    var i = Object.keys(g).map(function(h) {
      return "".concat(h, "=").concat(g[h]);
    }).join("&");
    p = "".concat(p, "&").concat(i);
  }
  return "".concat(n).concat(r).concat(l, "?").concat(p);
};
function fi() {
  var e = window.location.origin, t = pr("qw"), n = (t == null ? void 0 : t.corpId) || (t == null ? void 0 : t.corpid), r = "".concat(e, "/common-login/#/error?code=999999");
  if (n) {
    var u = li(t);
    r = "".concat(e, "/wxwork/v1/auth?corpId=").concat(n, "&state=123&redirect=").concat(encodeURIComponent(u));
  }
  window.location.replace(r);
}
function ir(e, t) {
  return te(this, void 0, void 0, function() {
    var n, r, u, s, l, T, p, v, g, i, h, m, G, D, O, U, N, Z, Y, B, R, L, x, K, P;
    return re(this, function(b) {
      switch (b.label) {
        case 0:
          n = t || {}, r = n.noAuthPage, u = n.redirectNoAuth, s = u === void 0 ? !0 : u, l = n.onError, T = n.type, p = T === void 0 ? "pc" : T, v = n.clearSensitiveParams, g = r || oi.bind({}, p), i = ii.bind({}, p), b.label = 1;
        case 1:
          return b.trys.push([1, 3, , 4]), [4, ei({
            sessionId: e,
            type: p
          })];
        case 2:
          return h = b.sent(), m = h, G = m.success, D = m.data, O = m.code, U = m.msg, G ? (N = D.companyStatus, Z = D.scrmEnable, Y = D.identity, !N || !Z && Y !== "admin" ? (l == null || l(N ? "暂无权限登录，请联系管理员！" : "该账号已停用，请联系管理员！"), s && ct(g, {
            companyStatus: N,
            scrmEnable: Z
          }), [2, !1]) : (ro(D, p === "pc" ? "pc" : "qw"), B = location.href.includes("autoLogin=true"), v && B && (R = location.pathname, L = location.hash, x = L.split("?")[0], K = "".concat(R).concat(x), window.history.replaceState(null, "", K)), [2, !0])) : (ct(i, {
            code: O,
            msg: U
          }), [2, !1]);
        case 3:
          return P = b.sent(), console.error(P), ct(i, {
            msg: "出错了"
          }), [2, !1];
        case 4:
          return [2];
      }
    });
  });
}
function di(e) {
  return te(this, void 0, void 0, function() {
    var t, n, r, u, s, l, T, p, v, g, i;
    return re(this, function(h) {
      switch (h.label) {
        case 0:
          return t = e || {}, n = t.whiteList, r = n === void 0 ? ni : n, u = t.forceRequest, s = t.sessionId, l = t.checkLocalUserSid, T = t.authPage, p = t.type, ai(r) && !u ? [2, !1] : (v = fr(), g = s || v.sessionId, g ? (no(v), [4, ir(g, e)]) : [3, 2]);
        case 1:
          return [2, h.sent()];
        case 2:
          return i = Ye(p), i ? l ? [4, ir(i, e)] : [3, 4] : [3, 5];
        case 3:
          return [2, h.sent()];
        case 4:
          return [2, !0];
        case 5:
          return p === "pc" ? ci(T) : fi(), [2, !1];
      }
    });
  });
}
var lt = 50;
function Ti(e) {
  var t = null, n, r = 16, u = 0, s = 4, l = 6, T = 8, p = 12, v = 1e4, g = Ie(), i = e.platform === "qw_manage" ? "pc" : "qw";
  function h() {
    if (!(lt <= 0)) {
      --lt;
      var b = wr.getSocketUrl(), I = Ye(i);
      if (!b || !I) {
        console.error("websocket url or sid is null");
        return;
      }
      t && K(), t = new WebSocket(b), t.binaryType = "arraybuffer", G(), D(), O();
    }
  }
  function m() {
    lt <= 0 || t.readyState === 3 && (h(), zt(m, v));
  }
  function G() {
    t.onopen = function() {
      L({
        mid: Ye(i) || "",
        platform: e.platform
      });
    };
  }
  function D() {
    t.onclose = function() {
      n && clearInterval(n), zt(m, v * 2);
    };
  }
  function O() {
    t.onmessage = function(b) {
      var I = b.data, H = U(I), C = H.packetLength, F = H.headerLength, j = H.op, z = {
        3: Y,
        8: N,
        9: B
      }, ie = z[j] || Z;
      ie(I, C, F);
    };
  }
  function U(b) {
    var I = new DataView(b, 0), H = I.getInt32(u), C = I.getInt16(s), F = I.getInt16(l), j = I.getInt32(T), z = I.getInt32(p);
    return {
      packetLength: H,
      headerLength: C,
      ver: F,
      op: j,
      seq: z
    };
  }
  function N() {
    R(), n && clearInterval(n), n = setInterval(function() {
      R();
    }, 30 * 1e3);
  }
  function Z(b, I, H) {
    var C = new TextDecoder(), F = C.decode(b.slice(I, H));
    g.dispatch(de.WebSocket, F);
  }
  function Y() {
    console.log("service heartbeat");
  }
  function B(b, I) {
    for (var H = new DataView(b, 0), C = r; C < b.byteLength; C += I) {
      var F = H.getInt32(C), j = H.getInt16(C + s);
      Z(b, C + j, C + F);
    }
  }
  function R() {
    var b = new ArrayBuffer(r), I = new DataView(b, 0);
    I.setInt32(u, r), I.setInt16(s, r), I.setInt16(l, 1), I.setInt32(T, 2), I.setInt32(p, 1), t.send(b);
  }
  function L(b) {
    var I = new TextEncoder(), H = new ArrayBuffer(r), C = new DataView(H, 0), F = I.encode(JSON.stringify(b));
    C.setInt32(u, r + F.byteLength), C.setInt16(s, r), C.setInt16(l, 1), C.setInt32(T, 7), C.setInt32(p, 1), t.send(x(H, F));
  }
  function x(b, I) {
    var H = new Uint8Array(b), C = new Uint8Array(I), F = new Uint8Array(H.byteLength + C.byteLength);
    return F.set(H, 0), F.set(C, H.byteLength), F.buffer;
  }
  function K() {
    t && (t.onclose = null, t.close()), t = null;
  }
  function P() {
    return t;
  }
  return Q(Q({}, g), { connect: h, destroy: K, getWx: P });
}
function Si(e) {
  return window.__ITIMO_WEB_SOCKET || (window.__ITIMO_WEB_SOCKET = Ti(e), window.__ITIMO_WEB_SOCKET.connect()), window.__ITIMO_WEB_SOCKET;
}
var ar;
(function(e) {
  function t() {
    var u = Ie();
    u.dispatch(de.ReloadMicroPage);
  }
  e.emit = t;
  function n(u) {
    var s = Ie();
    s.on(de.ReloadMicroPage, u);
  }
  e.on = n;
  function r(u) {
    var s = Ie();
    s.off(de.ReloadMicroPage, u);
  }
  e.off = r;
})(ar || (ar = {}));
function hi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ir = { exports: {} };
(function(e) {
  /*!mobile-detect v1.4.5 2021-03-13*/
  /*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
  (function(t, n) {
    t(function() {
      var r = {};
      r.mobileDetectRules = {
        phones: {
          iPhone: "\\biPhone\\b|\\biPod\\b",
          BlackBerry: "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
          Pixel: "; \\bPixel\\b",
          HTC: "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
          Nexus: "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
          Dell: "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
          Motorola: "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
          Samsung: "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
          LG: "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
          Sony: "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
          Asus: "Asus.*Galaxy|PadFone.*Mobile",
          Xiaomi: "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
          NokiaLumia: "Lumia [0-9]{3,4}",
          Micromax: "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
          Palm: "PalmSource|Palm",
          Vertu: "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
          Pantech: "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
          Fly: "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
          Wiko: "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
          iMobile: "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
          SimValley: "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
          Wolfgang: "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
          Alcatel: "Alcatel",
          Nintendo: "Nintendo (3DS|Switch)",
          Amoi: "Amoi",
          INQ: "INQ",
          OnePlus: "ONEPLUS",
          GenericPhone: "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
        },
        tablets: {
          iPad: "iPad|iPad.*Mobile",
          NexusTablet: "Android.*Nexus[\\s]+(7|9|10)",
          GoogleTablet: "Android.*Pixel C",
          SamsungTablet: "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
          Kindle: "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk/[0-9.]+ like Chrome/[0-9.]+ (?!Mobile)",
          SurfaceTablet: "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
          HPTablet: "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
          AsusTablet: "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
          BlackBerryTablet: "PlayBook|RIM Tablet",
          HTCtablet: "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
          MotorolaTablet: "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
          NookTablet: "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
          AcerTablet: "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
          ToshibaTablet: "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
          LGTablet: "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
          FujitsuTablet: "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
          PrestigioTablet: "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
          LenovoTablet: "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
          DellTablet: "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
          YarvikTablet: "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
          MedionTablet: "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
          ArnovaTablet: "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
          IntensoTablet: "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
          IRUTablet: "M702pro",
          MegafonTablet: "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
          EbodaTablet: "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
          AllViewTablet: "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
          ArchosTablet: "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
          AinolTablet: "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
          NokiaLumiaTablet: "Lumia 2520",
          SonyTablet: "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
          PhilipsTablet: "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
          CubeTablet: "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
          CobyTablet: "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
          MIDTablet: "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
          MSITablet: "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
          SMiTTablet: "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
          RockChipTablet: "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
          FlyTablet: "IQ310|Fly Vision",
          bqTablet: "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
          HuaweiTablet: "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
          NecTablet: "\\bN-06D|\\bN-08D",
          PantechTablet: "Pantech.*P4100",
          BronchoTablet: "Broncho.*(N701|N708|N802|a710)",
          VersusTablet: "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
          ZyncTablet: "z1000|Z99 2G|z930|z990|z909|Z919|z900",
          PositivoTablet: "TB07STA|TB10STA|TB07FTA|TB10FTA",
          NabiTablet: "Android.*\\bNabi",
          KoboTablet: "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
          DanewTablet: "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
          TexetTablet: "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
          PlaystationTablet: "Playstation.*(Portable|Vita)",
          TrekstorTablet: "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
          PyleAudioTablet: "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
          AdvanTablet: "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
          DanyTechTablet: "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
          GalapadTablet: "Android [0-9.]+; [a-z-]+; \\bG1\\b",
          MicromaxTablet: "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
          KarbonnTablet: "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
          AllFineTablet: "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
          PROSCANTablet: "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
          YONESTablet: "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
          ChangJiaTablet: "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
          GUTablet: "TX-A1301|TX-M9002|Q702|kf026",
          PointOfViewTablet: "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
          OvermaxTablet: "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
          HCLTablet: "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
          DPSTablet: "DPS Dream 9|DPS Dual 7",
          VistureTablet: "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
          CrestaTablet: "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
          MediatekTablet: "\\bMT8125|MT8389|MT8135|MT8377\\b",
          ConcordeTablet: "Concorde([ ]+)?Tab|ConCorde ReadMan",
          GoCleverTablet: "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
          ModecomTablet: "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
          VoninoTablet: "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
          ECSTablet: "V07OT2|TM105A|S10OT1|TR10CS1",
          StorexTablet: "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
          VodafoneTablet: "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
          EssentielBTablet: "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
          RossMoorTablet: "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
          iMobileTablet: "i-mobile i-note",
          TolinoTablet: "tolino tab [0-9.]+|tolino shine",
          AudioSonicTablet: "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
          AMPETablet: "Android.* A78 ",
          SkkTablet: "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
          TecnoTablet: "TECNO P9|TECNO DP8D",
          JXDTablet: "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
          iJoyTablet: "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
          FX2Tablet: "FX2 PAD7|FX2 PAD10",
          XoroTablet: "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
          ViewsonicTablet: "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
          VerizonTablet: "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
          OdysTablet: "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
          CaptivaTablet: "CAPTIVA PAD",
          IconbitTablet: "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
          TeclastTablet: "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
          OndaTablet: "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
          JaytechTablet: "TPC-PA762",
          BlaupunktTablet: "Endeavour 800NG|Endeavour 1010",
          DigmaTablet: "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
          EvolioTablet: "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
          LavaTablet: "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
          AocTablet: "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
          MpmanTablet: "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
          CelkonTablet: "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
          WolderTablet: "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
          MediacomTablet: "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
          MiTablet: "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
          NibiruTablet: "Nibiru M1|Nibiru Jupiter One",
          NexoTablet: "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
          LeaderTablet: "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
          UbislateTablet: "UbiSlate[\\s]?7C",
          PocketBookTablet: "Pocketbook",
          KocasoTablet: "\\b(TB-1207)\\b",
          HisenseTablet: "\\b(F5281|E2371)\\b",
          Hudl: "Hudl HT7S3|Hudl 2",
          TelstraTablet: "T-Hub2",
          GenericTablet: "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
        },
        oss: {
          AndroidOS: "Android",
          BlackBerryOS: "blackberry|\\bBB10\\b|rim tablet os",
          PalmOS: "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
          SymbianOS: "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
          WindowsMobileOS: "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
          WindowsPhoneOS: "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
          iOS: "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
          iPadOS: "CPU OS 13",
          SailfishOS: "Sailfish",
          MeeGoOS: "MeeGo",
          MaemoOS: "Maemo",
          JavaOS: "J2ME/|\\bMIDP\\b|\\bCLDC\\b",
          webOS: "webOS|hpwOS",
          badaOS: "\\bBada\\b",
          BREWOS: "BREW"
        },
        uas: {
          Chrome: "\\bCrMo\\b|CriOS|Android.*Chrome/[.0-9]* (Mobile)?",
          Dolfin: "\\bDolfin\\b",
          Opera: "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR/[0-9.]+$|Coast/[0-9.]+",
          Skyfire: "Skyfire",
          Edge: "\\bEdgiOS\\b|Mobile Safari/[.0-9]* Edge",
          IE: "IEMobile|MSIEMobile",
          Firefox: "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
          Bolt: "bolt",
          TeaShark: "teashark",
          Blazer: "Blazer",
          Safari: "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
          WeChat: "\\bMicroMessenger\\b",
          UCBrowser: "UC.*Browser|UCWEB",
          baiduboxapp: "baiduboxapp",
          baidubrowser: "baidubrowser",
          DiigoBrowser: "DiigoBrowser",
          Mercury: "\\bMercury\\b",
          ObigoBrowser: "Obigo",
          NetFront: "NF-Browser",
          GenericBrowser: "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
          PaleMoon: "Android.*PaleMoon|Mobile.*PaleMoon"
        },
        props: {
          Mobile: "Mobile/[VER]",
          Build: "Build/[VER]",
          Version: "Version/[VER]",
          VendorID: "VendorID/[VER]",
          iPad: "iPad.*CPU[a-z ]+[VER]",
          iPhone: "iPhone.*CPU[a-z ]+[VER]",
          iPod: "iPod.*CPU[a-z ]+[VER]",
          Kindle: "Kindle/[VER]",
          Chrome: [
            "Chrome/[VER]",
            "CriOS/[VER]",
            "CrMo/[VER]"
          ],
          Coast: [
            "Coast/[VER]"
          ],
          Dolfin: "Dolfin/[VER]",
          Firefox: [
            "Firefox/[VER]",
            "FxiOS/[VER]"
          ],
          Fennec: "Fennec/[VER]",
          Edge: "Edge/[VER]",
          IE: [
            "IEMobile/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident/[0-9.]+;.*rv:[VER]"
          ],
          NetFront: "NetFront/[VER]",
          NokiaBrowser: "NokiaBrowser/[VER]",
          Opera: [
            " OPR/[VER]",
            "Opera Mini/[VER]",
            "Version/[VER]"
          ],
          "Opera Mini": "Opera Mini/[VER]",
          "Opera Mobi": "Version/[VER]",
          UCBrowser: [
            "UCWEB[VER]",
            "UC.*Browser/[VER]"
          ],
          MQQBrowser: "MQQBrowser/[VER]",
          MicroMessenger: "MicroMessenger/[VER]",
          baiduboxapp: "baiduboxapp/[VER]",
          baidubrowser: "baidubrowser/[VER]",
          SamsungBrowser: "SamsungBrowser/[VER]",
          Iron: "Iron/[VER]",
          Safari: [
            "Version/[VER]",
            "Safari/[VER]"
          ],
          Skyfire: "Skyfire/[VER]",
          Tizen: "Tizen/[VER]",
          Webkit: "webkit[ /][VER]",
          PaleMoon: "PaleMoon/[VER]",
          SailfishBrowser: "SailfishBrowser/[VER]",
          Gecko: "Gecko/[VER]",
          Trident: "Trident/[VER]",
          Presto: "Presto/[VER]",
          Goanna: "Goanna/[VER]",
          iOS: " \\bi?OS\\b [VER][ ;]{1}",
          Android: "Android [VER]",
          Sailfish: "Sailfish [VER]",
          BlackBerry: [
            "BlackBerry[\\w]+/[VER]",
            "BlackBerry.*Version/[VER]",
            "Version/[VER]"
          ],
          BREW: "BREW [VER]",
          Java: "Java/[VER]",
          "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
          ],
          "Windows Phone": "Windows Phone [VER]",
          "Windows CE": "Windows CE/[VER]",
          "Windows NT": "Windows NT [VER]",
          Symbian: [
            "SymbianOS/[VER]",
            "Symbian/[VER]"
          ],
          webOS: [
            "webOS/[VER]",
            "hpwOS/[VER];"
          ]
        },
        utils: {
          Bot: "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
          MobileBot: "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker/M1A1-R2D2",
          DesktopMode: "WPDesktop",
          TV: "SonyDTV|HbbTV",
          WebKit: "(webkit)[ /]([\\w.]+)",
          Console: "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
          Watch: "SM-V700"
        }
      }, r.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
      };
      var u = Object.prototype.hasOwnProperty, s;
      r.FALLBACK_PHONE = "UnknownPhone", r.FALLBACK_TABLET = "UnknownTablet", r.FALLBACK_MOBILE = "UnknownMobile", s = "isArray" in Array ? Array.isArray : function(i) {
        return Object.prototype.toString.call(i) === "[object Array]";
      };
      function l(i, h) {
        return i != null && h != null && i.toLowerCase() === h.toLowerCase();
      }
      function T(i, h) {
        var m, G, D = i.length;
        if (!D || !h)
          return !1;
        for (m = h.toLowerCase(), G = 0; G < D; ++G)
          if (m === i[G].toLowerCase())
            return !0;
        return !1;
      }
      function p(i) {
        for (var h in i)
          u.call(i, h) && (i[h] = new RegExp(i[h], "i"));
      }
      function v(i) {
        return (i || "").substr(0, 500);
      }
      (function() {
        var h, m, G, D, O, U, N = r.mobileDetectRules;
        for (h in N.props)
          if (u.call(N.props, h)) {
            for (m = N.props[h], s(m) || (m = [m]), O = m.length, D = 0; D < O; ++D)
              G = m[D], U = G.indexOf("[VER]"), U >= 0 && (G = G.substring(0, U) + "([\\w._\\+]+)" + G.substring(U + 5)), m[D] = new RegExp(G, "i");
            N.props[h] = m;
          }
        p(N.oss), p(N.phones), p(N.tablets), p(N.uas), p(N.utils), N.oss0 = {
          WindowsPhoneOS: N.oss.WindowsPhoneOS,
          WindowsMobileOS: N.oss.WindowsMobileOS
        };
      })(), r.findMatch = function(i, h) {
        for (var m in i)
          if (u.call(i, m) && i[m].test(h))
            return m;
        return null;
      }, r.findMatches = function(i, h) {
        var m = [];
        for (var G in i)
          u.call(i, G) && i[G].test(h) && m.push(G);
        return m;
      }, r.getVersionStr = function(i, h) {
        var m = r.mobileDetectRules.props, G, D, O, U;
        if (u.call(m, i)) {
          for (G = m[i], O = G.length, D = 0; D < O; ++D)
            if (U = G[D].exec(h), U !== null)
              return U[1];
        }
        return null;
      }, r.getVersion = function(i, h) {
        var m = r.getVersionStr(i, h);
        return m ? r.prepareVersionNo(m) : NaN;
      }, r.prepareVersionNo = function(i) {
        var h;
        return h = i.split(/[a-z._ \/\-]/i), h.length === 1 && (i = h[0]), h.length > 1 && (i = h[0] + ".", h.shift(), i += h.join("")), Number(i);
      }, r.isMobileFallback = function(i) {
        return r.detectMobileBrowsers.fullPattern.test(i) || r.detectMobileBrowsers.shortPattern.test(i.substr(0, 4));
      }, r.isTabletFallback = function(i) {
        return r.detectMobileBrowsers.tabletPattern.test(i);
      }, r.prepareDetectionCache = function(i, h, m) {
        if (i.mobile === n) {
          var G, D, O;
          if (D = r.findMatch(r.mobileDetectRules.tablets, h), D) {
            i.mobile = i.tablet = D, i.phone = null;
            return;
          }
          if (G = r.findMatch(r.mobileDetectRules.phones, h), G) {
            i.mobile = i.phone = G, i.tablet = null;
            return;
          }
          r.isMobileFallback(h) ? (O = g.isPhoneSized(m), O === n ? (i.mobile = r.FALLBACK_MOBILE, i.tablet = i.phone = null) : O ? (i.mobile = i.phone = r.FALLBACK_PHONE, i.tablet = null) : (i.mobile = i.tablet = r.FALLBACK_TABLET, i.phone = null)) : r.isTabletFallback(h) ? (i.mobile = i.tablet = r.FALLBACK_TABLET, i.phone = null) : i.mobile = i.tablet = i.phone = null;
        }
      }, r.mobileGrade = function(i) {
        var h = i.mobile() !== null;
        return (
          // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
          i.os("iOS") && i.version("iPad") >= 4.3 || i.os("iOS") && i.version("iPhone") >= 3.1 || i.os("iOS") && i.version("iPod") >= 3.1 || // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
          // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
          // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
          // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
          i.version("Android") > 2.1 && i.is("Webkit") || // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
          i.version("Windows Phone OS") >= 7 || // Blackberry 7 - Tested on BlackBerry Torch 9810
          // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
          i.is("BlackBerry") && i.version("BlackBerry") >= 6 || // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
          i.match("Playbook.*Tablet") || // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
          i.version("webOS") >= 1.4 && i.match("Palm|Pre|Pixi") || // Palm WebOS 3.0  - Tested on HP TouchPad
          i.match("hp.*TouchPad") || // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
          i.is("Firefox") && i.version("Firefox") >= 12 || // Chrome for Android - Tested on Android 4.0, 4.1 device
          i.is("Chrome") && i.is("AndroidOS") && i.version("Android") >= 4 || // Skyfire 4.1 - Tested on Android 2.3 device
          i.is("Skyfire") && i.version("Skyfire") >= 4.1 && i.is("AndroidOS") && i.version("Android") >= 2.3 || // Opera Mobile 11.5-12: Tested on Android 2.3
          i.is("Opera") && i.version("Opera Mobi") > 11 && i.is("AndroidOS") || // Meego 1.2 - Tested on Nokia 950 and N9
          i.is("MeeGoOS") || // Tizen (pre-release) - Tested on early hardware
          i.is("Tizen") || // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
          // @todo: more tests here!
          i.is("Dolfin") && i.version("Bada") >= 2 || // UC Browser - Tested on Android 2.3 device
          (i.is("UC Browser") || i.is("Dolfin")) && i.version("Android") >= 2.3 || // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
          i.match("Kindle Fire") || i.is("Kindle") && i.version("Kindle") >= 3 || // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
          i.is("AndroidOS") && i.is("NookTablet") || // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
          i.version("Chrome") >= 11 && !h || // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
          i.version("Safari") >= 5 && !h || // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
          i.version("Firefox") >= 4 && !h || // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
          i.version("MSIE") >= 7 && !h || // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
          // @reference: http://my.opera.com/community/openweb/idopera/
          i.version("Opera") >= 10 && !h ? "A" : i.os("iOS") && i.version("iPad") < 4.3 || i.os("iOS") && i.version("iPhone") < 3.1 || i.os("iOS") && i.version("iPod") < 3.1 || // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
          i.is("Blackberry") && i.version("BlackBerry") >= 5 && i.version("BlackBerry") < 6 || //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
          i.version("Opera Mini") >= 5 && i.version("Opera Mini") <= 6.5 && (i.version("Android") >= 2.3 || i.is("iOS")) || // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
          i.match("NokiaN8|NokiaC7|N97.*Series60|Symbian/3") || // @todo: report this (tested on Nokia N71)
          i.version("Opera Mobi") >= 11 && i.is("SymbianOS") ? "B" : (
            // Blackberry 4.x - Tested on the Curve 8330
            (i.version("BlackBerry") < 5 || // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            i.match("MSIEMobile|Windows CE.*Mobile") || i.version("Windows Mobile") <= 5.2, "C")
          )
        );
      }, r.detectOS = function(i) {
        return r.findMatch(r.mobileDetectRules.oss0, i) || r.findMatch(r.mobileDetectRules.oss, i);
      }, r.getDeviceSmallerSide = function() {
        return window.screen.width < window.screen.height ? window.screen.width : window.screen.height;
      };
      function g(i, h) {
        this.ua = v(i), this._cache = {}, this.maxPhoneWidth = h || 600;
      }
      return g.prototype = {
        constructor: g,
        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function() {
          return r.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.mobile;
        },
        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function() {
          return r.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.phone;
        },
        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function() {
          return r.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.tablet;
        },
        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function() {
          return this._cache.userAgent === n && (this._cache.userAgent = r.findMatch(r.mobileDetectRules.uas, this.ua)), this._cache.userAgent;
        },
        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function() {
          return this._cache.userAgents === n && (this._cache.userAgents = r.findMatches(r.mobileDetectRules.uas, this.ua)), this._cache.userAgents;
        },
        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function() {
          return this._cache.os === n && (this._cache.os = r.detectOS(this.ua)), this._cache.os;
        },
        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function(i) {
          return r.getVersion(i, this.ua);
        },
        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function(i) {
          return r.getVersionStr(i, this.ua);
        },
        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function(i) {
          return T(this.userAgents(), i) || l(i, this.os()) || l(i, this.phone()) || l(i, this.tablet()) || T(r.findMatches(r.mobileDetectRules.utils, this.ua), i);
        },
        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function(i) {
          return i instanceof RegExp || (i = new RegExp(i, "i")), i.test(this.ua);
        },
        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function(i) {
          return g.isPhoneSized(i || this.maxPhoneWidth);
        },
        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function() {
          return this._cache.grade === n && (this._cache.grade = r.mobileGrade(this)), this._cache.grade;
        }
      }, typeof window < "u" && window.screen ? g.isPhoneSized = function(i) {
        return i < 0 ? n : r.getDeviceSmallerSide() <= i;
      } : g.isPhoneSized = function() {
      }, g._impl = r, g.version = "1.4.5 2021-03-13", g;
    });
  })(function(t) {
    if (e.exports)
      return function(n) {
        e.exports = n();
      };
    if (typeof window < "u")
      return function(n) {
        window.MobileDetect = n();
      };
    throw new Error("unknown environment");
  }());
})(Ir);
var bi = Ir.exports;
const pi = /* @__PURE__ */ hi(bi), vi = () => {
  try {
    const e = window.navigator.userAgent, t = new pi(e);
    let n = t.os(), r = "";
    if (t.os() == "iOS")
      n = t.os() + t.version("iPhone"), r = t.mobile() || "";
    else if (n == "AndroidOS") {
      n = t.os() + t.version("Android");
      const s = e.split(";"), l = mi(s, "Build/");
      Number(l) > -1 && (r = s[Number(l)].substring(0, s[Number(l)].indexOf("Build/")));
    }
    const u = Date.now().toString(36);
    return `${n}_${r}_${u}`;
  } catch {
    return null;
  }
}, mi = (e, t) => {
  for (let n in e)
    if (e[n].indexOf(t) > 0)
      return n;
  return -1;
}, Di = () => JSON.parse(localStorage.getItem("c_user") || "{}"), Ai = function(e) {
  let t = e.url, n = "";
  Object.entries(e.params).forEach((u) => {
    u[0] && (n += `${n ? "&" : ""}${u[0]}=${u[1] || ""}`);
  }), e.method === "get" && (t += `?${n}`, n = "");
  var r = new XMLHttpRequest();
  return r.open(e.method, t, !0), e.method === "post" && (r.setRequestHeader("Content-type", "application/json; charset=utf-8"), n = JSON.stringify(e.params)), r.setRequestHeader("Access-Control-Allow-Origin", "*"), r.setRequestHeader("Accept", "*/*"), r.send(n), new Promise(function(u, s) {
    r.onload = function() {
      u(JSON.parse((r == null ? void 0 : r.response) || "{}"));
    }, r.onerror = function(l) {
      s(l);
    };
  });
}, Pi = (e) => {
  if (!e)
    throw new Error("缺少接口配置config相关参数!");
  if (!e.webGateway)
    throw new Error("请配置请求方式webGateway");
  const { userIdentityDetail: t } = gi(e.webGateway);
  return { userIdentityDetail: t };
}, gi = (e) => {
  class t {
    constructor() {
      this.userIdentityDetail = (r, u) => {
        const s = u && u.header ? { ...u.header, "x-api-version": "v1.0.20240516100100672" } : { "x-api-version": "v1.0.20240516100100672" };
        return e({
          optionName: "go-open-ecosystem-center.goopenecosystemcenter.UserAuthorizerService.UserIdentityDetail",
          params: r,
          extra: {
            application_name: "go-open-ecosystem-center",
            service_name: "UserAuthorizerService",
            method_name: "UserIdentityDetail",
            protobuf_version: "v1.0.20240516100100672",
            res_type_name: "UserIdentityDetailResponse",
            ...u,
            header: s
          }
        });
      };
    }
  }
  return new t();
}, { VUE_APP_M_C_BASE_URL: Mi } = window && window.envConfig;
var ue;
class Hi {
  constructor(t) {
    Vt(this, ue, void 0);
    Ft(this, ue, t);
  }
  initAuthSDKType() {
    !he && lr ? this.officialAuth() : this.defaultH5Login();
  }
  // 公众号
  officialAuth() {
    const { VUE_APP_WX_OPEN_BASE_URL: t } = window && window.envConfig, { companyId: n, scope: r = "snsapi_userinfo", subDomain: u } = Se(this, ue), s = {
      url: `${t}/go-open-ecosystem-center/api/v1/user-authorizer/oauth2`,
      urlParams: {
        companyId: n || _n(),
        adId: ft(),
        scope: r || Hn(),
        redirectURL: encodeURIComponent(window.location.href),
        subDomain: u
      },
      needBase64: !0
    };
    this.wxAuthHref(s);
  }
  // 浏览器
  // H5 先获取“cfx_icorki”是否存在，存在直接返回getItem value，否则生成value并推入indexDB
  async defaultH5Login() {
    try {
      const t = await Zt.platform.getItem("cfx_icorki");
      if (t)
        return { code: t };
      const n = await vi() || "";
      return await Zt.platform.setItem("cfx_icorki", n), await this.setUserInfoV1Code({ code: n }), { code: n };
    } catch (t) {
      return console.error("h5 login!", t.message), null;
    }
  }
  async setUserInfoV1Code({ appId: t, code: n }) {
    var r, u;
    try {
      const s = {
        appId: t,
        code: n,
        subDomain: Se(this, ue).subDomain,
        accountId: Se(this, ue).companyId
      };
      t || delete s.appId;
      const l = await Ai({
        method: "post",
        url: `${Mi}/go-mid-user-login/toc/v1/auth`,
        params: {
          ...s,
          adId: ft()
        }
      });
      if (!l)
        return null;
      if (l.code === 10030301 || l.code !== 0)
        return console.error(l.msg), null;
      const T = {
        sessionId: (r = l.data) == null ? void 0 : r.sessionId,
        accountId: Se(this, ue).companyId,
        expires: 6048e5,
        startTime: (/* @__PURE__ */ new Date()).getTime()
      };
      localStorage.setItem("c_user", JSON.stringify(T));
      const v = await Pi({ webGateway: Se(this, ue).webGateway }).userIdentityDetail({ subDomain: Se(this, ue).subDomain }, {
        header: {
          Authorization: T.sessionId,
          "x-auth-accountid": T.accountId
        }
      }), g = JSON.parse(localStorage.getItem("c_user") || "{}"), i = ((u = v == null ? void 0 : v.data) == null ? void 0 : u.data) || {};
      return i.unionId = (i == null ? void 0 : i.targetId) || "", v.code === "0" && localStorage.setItem("c_user", JSON.stringify({ ...g, ...i || {}, appId: t })), v.data;
    } catch (s) {
      return console.error("js http!", s.message), null;
    }
  }
  wxAuthHref(t) {
    if (t.urlParams.redirectURL === "") {
      const { origin: r, pathname: u, hash: s } = window.location, l = s.split("?"), T = this.multiQmParse(s);
      ["code", "appid", "appId", "state", "openid"].forEach((v) => {
        delete T[v];
      });
      const p = this.urlEncode(T, !1, "").substr(1);
      t.urlParams.redirectURL = `${r}${u}${l[0]}?${p}`;
    }
    t.needBase64 && (t.urlParams.redirectURL = encodeURIComponent(t.urlParams.redirectURL));
    const n = `${t.url}?${this.urlEncode(t.urlParams, !1, "")}`;
    window.location.replace(n);
  }
  urlEncode(t, n = !1, r) {
    if (t == null)
      return "";
    let u = "";
    const s = typeof t;
    if (["string", "number", "boolean"].includes(s))
      u += `&${r}=${n ? encodeURIComponent(t) : t}`;
    else
      for (const l in t) {
        const T = r ? r + (t instanceof Array ? "[" + l + "]" : "." + l) : l;
        u += this.urlEncode(t[l], n, T);
      }
    return u;
  }
  multiQmParse(t) {
    let n = {};
    if (t.split("?").length > 2) {
      const u = window.location.hash.indexOf("?") + 1;
      window.location.hash.substring(u).split("&").forEach((l) => {
        if (l.indexOf("?")) {
          const T = l.indexOf("?") + 1, p = l.substring(0, T).split("=");
          p[0] && (n[p[0]] = p[1]);
          const v = l.substring(T).split("=");
          v[0] && (n[v[0]] = v[1]);
        } else if (l.indexOf("?") === -1) {
          const [T, p] = l.split("=");
          n[T] = p;
        }
      });
    } else
      n = this.fquery(window.location.hash.split("?")[1]);
    return n;
  }
  fquery(t = window.location.search.substr(1)) {
    const n = /([^=&\s]+)[=\s]*([^&\s]*)/g, r = {};
    for (; n.exec(t); )
      r[RegExp.$1] = RegExp.$2;
    return r;
  }
}
ue = new WeakMap();
const _i = function(e = "c_user") {
  return !wi(e);
};
function wi(e) {
  let t = JSON.parse(window.localStorage.getItem(e) || "{}"), { expires: n, startTime: r } = t;
  return n && r ? (/* @__PURE__ */ new Date()).getTime() - r > n || !(t != null && t.targetId) ? (window.localStorage.removeItem(e), null) : t : null;
}
export {
  Hi as AuthSDK,
  Bi as WxSDK,
  Ci as deleteOtherUrlParams,
  Di as getCUser,
  _i as isNeedAuth,
  Fn as loadMountDocument
};
